/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from "axios/dist/axios.min.js";
import Request from '../../utils/request';
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import "./style.less";

// 商品维度字段映射关系
const PRODUCT_GOODS_INFO_FIELDS_MAP = {
  "id": "goods_id",
  "goods_id": "goods_id",
  "name": "goods_name",
  "title": "goods_name",
  "url": "url",
  "image": "pic",
  "price": "price",
  "original_price": "official_price",
  "recommend": "recommend",
  "sell_point": "real_sales_num",
  "real_gmv": "real_gmv_30",
  "beltImg": "beltImg",
  "unit_price_text": "unit_price_text",
  "productImageCustom": "pic"
}

// 配色维度字段映射关系
const PRODUCT_STYLE_INFO_FIELDS_MAP = {
  "id": "style_id",
  "goods_id": "goods_id",
  "name": "goods_name",
  "title": "goods_name",
  "url": "url",
  "image": "pic",
  "price": "price",
  "original_price": "official_price",
  "recommend": "recommend",
  "sell_point": "real_sales_num_30",
  "real_gmv": "real_gmv",
  "beltImg": "beltImg",
  "unit_price_text": "unit_price_text",
  "productImageCustom": "pic"
}

// 乐高页面类目和类目新人补贴类目对应关系
const CategoryNewcomer = {
  "鞋类": 1,
  "服饰": 2,
  "运动": 3,
  "数码": 4,
  "美妆": 5,
  "潮玩": 6,
  "配饰": 7,
  "手表": 8,
  "箱包": 9,
  "酒水": 10,
  "居家": 12,
  "/": 12,
  "母婴": 13,
  "宠物": 14,
  "营养保健": 15,
  "电器": 16,
  "个护": 17,
  "生活服务": 18
}

const custonLabels = [
  'https://static.shihuocdn.cn/admin/files/20231214/34551b970dd81b98178802d32a0a113e.png',
  'https://static.shihuocdn.cn/admin/files/20231214/d182a910641e15ab35010c70ed6b8435.png',
  'https://static.shihuocdn.cn/admin/files/20231214/e0e61451038ad18153d03627c8d9e152.png',
  'https://static.shihuocdn.cn/admin/files/20231214/f46f599a05df691f749b2b767427f0a4.png',
  'https://static.shihuocdn.cn/admin/files/20231214/7a7183ee677fb38aa210c94f008598e5.png',
  'https://static.shihuocdn.cn/admin/files/20231214/8027eea558b6615b6d94f96654a3b0d1.png',
  'https://static.shihuocdn.cn/admin/files/20231214/a00823f49882862349eb0fd001654c4f.png',
  'https://static.shihuocdn.cn/admin/files/20231214/0da687bf0139def6dbc69a1da20807d0.png',
  'https://static.shihuocdn.cn/admin/files/20231214/dd92a4aa625e2d5faaa1f92b1548283a.png',
  'http://static.shihuocdn.cn/admin/files/20231214/34551b970dd81b98178802d32a0a113e.png',
  'http://static.shihuocdn.cn/admin/files/20231214/d182a910641e15ab35010c70ed6b8435.png',
  'http://static.shihuocdn.cn/admin/files/20231214/e0e61451038ad18153d03627c8d9e152.png',
  'http://static.shihuocdn.cn/admin/files/20231214/f46f599a05df691f749b2b767427f0a4.png',
  'http://static.shihuocdn.cn/admin/files/20231214/7a7183ee677fb38aa210c94f008598e5.png',
  'http://static.shihuocdn.cn/admin/files/20231214/8027eea558b6615b6d94f96654a3b0d1.png',
  'http://static.shihuocdn.cn/admin/files/20231214/a00823f49882862349eb0fd001654c4f.png',
  'http://static.shihuocdn.cn/admin/files/20231214/0da687bf0139def6dbc69a1da20807d0.png',
  'http://static.shihuocdn.cn/admin/files/20231214/dd92a4aa625e2d5faaa1f92b1548283a.png'
];

class PipelineProduct extends React.Component {
  constructor(props) {
    super(props);
    const { cardBaseConfig = {} } = props.config;
    const sortType = cardBaseConfig.sortType;
    // 初始化商品id列表数据
    const initList = sortType === '自定义排序' ? props.config.itemList.map(item => {
      return {
        ...item,
        title: item.name,
        url: item.productHref,
        image: item.productImageCustom || 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'
      };
    }) : props.config.itemList.map(item => {
      return {
        image: 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png', // 空白占位图
      };
    });
    this.initList = initList;
    this.state = {
      productList: initList,
      isFold: false,
      showPage: 1,
      pageSize: 0,
      visiable: false,
      mask_show: false,
      noticeVersionShow: false,
      backCount: 3,
      isCateNewUser: false,
      selectedItem: {},
      selectedIndex: '',
      showRectImg: false
    };
    this.countDownInterVal = null;
    this.sortTypeMap = {
      '自定义排序': 0,
      '销量': 4,
      'GMV': 6,
      '上新时间': 8,
      '热度': 18,
    };
    this.saleTypeMap = {
      '默认': 4,
      '近1天': 10,
      '近7天': 12,
      '近14天': 14,
      '近30天': 16
    },
    this.formTable = false;
    this.formType = '';
    this.page = 1;
    this.hasNext = true;
    this.isLoading = false;
    this.dataSourceConfig = {};  // 自定义表单数据源配置信息
    this.fieldMapTable = {};  // 当前选用的字段映射表
    this.initLayoutRowScroll = false;
    this.speed = utils.isAndroid() ? 0.5 : 1; // 滚动速度，每次增加的值
    this.scrollState = 'paused';
    this.scrollAnimation = null;
    this.isScrollEnd = false;
    this.delayTimeout = null;
    this.isAndroid = utils.isAndroid();
    this.isIphone14ProMax = utils.isIphone14ProMax();
    this.inViewArea = false;
    this.currentPosition = 0;
    this.pipelineProductRef = null;
    this.isIframe = utils.getParams('isIframe') == '1';
  }

  componentDidMount() {
    const { dataSourceStr = '', isLastComponent = false } = this.props;
    const { cardInfoConfig = {} } = this.props.config;
    if (cardInfoConfig && cardInfoConfig.newUserPrice === '新人价') {
      const verticals = window.classifyName
      this.getIfNewUser({verticals: CategoryNewcomer[verticals]})
    }
    let dataSource = [];
    if (dataSourceStr && dataSourceStr.indexOf('dataSourceStr') < 0) {
      dataSource = JSON.parse(decodeURIComponent(dataSourceStr))
    }
    const componentId = this.props['customAttributes']['data-component-id'];
    const findOne = dataSource.find(item => item.componentId == componentId);
    const { baseConfig, cardBaseConfig } = this.props.config;
    const productStyle = baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle);
    if (!findOne) {
      // 通过手动配置导入的数据源 走默认逻辑
      const productType = baseConfig.productType || (cardBaseConfig && cardBaseConfig.productType);
      if (productType === "商品id" || productType === "配色id" || productType === "skuId") {
        this.getProductListData();
      }
      if (productType === "商品集合id" || productType === "配色集合id") {
        this.getProductCollectionData(); 
      }
    } else {
      // 通过自定义表单导入的数据源 走分页加载逻辑
      this.formTable = true;
      this.dataSourceConfig = findOne;
      this.fieldMap = findOne.dataConfig.fieldMap;
      this.formType = findOne.dataConfig.formType;
      this.fieldMapTable = this.formType === 'goods' ? PRODUCT_GOODS_INFO_FIELDS_MAP : PRODUCT_STYLE_INFO_FIELDS_MAP;
      this.dataSourcePageLoad();
      if (productStyle !== '一行一排' && productStyle !== '多个商品，自动适配' && isLastComponent) {
        window.addEventListener('scroll', this.onScroll, true);
      }
    }

    if (productStyle === '多个商品，自动适配' && cardBaseConfig.isAutoCarousel === '是') {
      window.addEventListener('scroll', this.onPageScroll, true);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.productList !== prevState.productList && this.pipelineProductRef) {
      // 数据已渲染完成
      if (this.isIframe) {
        utils.SyncComponentsSizeAsync(this.pipelineProductRef);
      }
      // this.pipelineProductRef.parentNode.style.minHeight = 0;
    }
  }

  // 滚动监听
  onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    const height = document.documentElement.clientHeight || document.body.clientHeight;
    if ((scrollTop + height > scrollHeight - 500) && this.hasNext && !this.isLoading) {
      this.isLoading = true;
      this.page = this.page + 1;
      this.dataSourcePageLoad(this.page);
    }
  }

  // 滚动监听
  onPageScroll = (event) => {
    const element = this.goodsBodyRef;
    if (event.target === document && element) {
      const { verticalVisible, visibilityRatio } = this.isElementInViewport(element);
      if (verticalVisible && visibilityRatio >= 0.5) {
        // 进去可视区，切露出超过一半时，开始自动轮播
        this.inViewArea = true;
        this.startScrolling();
      } else {
        // 停止轮播
        this.inViewArea = false;
        this.stopScrolling();
      }
    }
  }

  // 多个商品自动适配，滚动监听
  onScrollLayoutRow = () => {
    if (this.props.config.cardBaseConfig.isAutoCarousel === '否') {
      return;
    }
    if (this.initLayoutRowScroll) {
      return;
    }
    this.initLayoutRowScroll = true;
    const goodsBody = this.goodsBodyRef;
    const progressBg = this.carouselBgRef;
    const progress = this.progressRef;
    if (goodsBody && progressBg && progress) {
      const goodsScrollWidth = goodsBody.scrollWidth - goodsBody.clientWidth;
      const progressWidth = progressBg.clientWidth - progress.clientWidth;
      goodsBody.addEventListener('scroll', () => {
        if (goodsBody.scrollLeft >= goodsScrollWidth) {
          this.isScrollEnd = true;
        }
        const progressLeft = (goodsBody.scrollLeft / goodsScrollWidth) * progressWidth;
        progress.style.left = progressLeft + 'px';
      });
    }

    this.handleScrollEvent();
  }

  // 设置 goods-body 的scrollLeft
  setGoodsBodyScrollLeft = () => {
    var transformStyle = window.getComputedStyle(this.goodsScrollRef).getPropertyValue('transform');
    var matrix = new window.WebKitCSSMatrix(transformStyle);
    var pausePosition = matrix.m41;
    var goodsScrollLeft = this.goodsBodyRef.scrollLeft;

    if (pausePosition != 0) {
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: -pausePosition + goodsScrollLeft
      })
    }
  }

  // 开始轮播
  startScrolling = () => {
    if (this.scrollState === 'paused') {
      this.scrollState = 'running';
      if (!this.isScrollEnd) {
        const animationDuration = this.getAnimationDuration();
        const animation = `scrollAnimation ${animationDuration}s linear 1s forwards`;
        this.goodsScrollRef.style.animation = animation;
        this.scrollAnimation = requestAnimationFrame(this.requestAnimationFrameScroll);
      }
    }
  }

  // 停止轮播
  stopScrolling = () => {
    this.scrollState = 'paused';
    cancelAnimationFrame(this.scrollAnimation);
    this.scrollAnimation = null;
    this.goodsScrollRef.style.animationPlayState = 'paused';
    if (this.isScrollEnd) {
      // 滚动到底部时，移除css animaton
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: this.goodsScrollRef.clientWidth - window.screen.width
      });
      this.goodsScrollRef.style.animation = 'none';
    } else {
      this.setGoodsBodyScrollLeft();
      this.goodsScrollRef.style.animation = 'none';
    }
  }

  handleScrollEvent = () => {
    this.goodsScrollRef.addEventListener('touchstart', () => {
      if (this.goodsScrollRef.style.animationPlayState == 'paused' || !this.inViewArea) {
        return;
      }
      this.goodsScrollRef.style.animationPlayState = 'paused';
      this.setGoodsBodyScrollLeft();
      this.goodsScrollRef.style.animation = 'none';
    });

    this.goodsScrollRef.addEventListener('touchend', () => {
      if (!this.inViewArea) {
        return;
      }
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
        this.delayTimeout = null;
      }
      this.delayTimeout = setTimeout(() => {
        if (!this.isScrollEnd) {
          const animationDuration = this.getAnimationDuration();
          const animation = `scrollAnimation ${animationDuration}s linear 0s forwards`;
          this.goodsScrollRef.style.animation = animation;
        }
      }, 1500)
      
    });
  }

  getScrollPosition = () => {
    if (!this.isScrollEnd) {
      const elementRect = this.goodsScrollRef.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const rightEdgeVisible = elementRect.right <= viewportWidth;
      if (rightEdgeVisible) {
        this.isScrollEnd = true;
      } else {
        const progressWidth = this.carouselBgRef.clientWidth - this.progressRef.clientWidth;
        const progressLeft = ((this.goodsScrollRef.clientWidth - elementRect.right) / (this.goodsScrollRef.clientWidth - viewportWidth)) * progressWidth;
        this.progressRef.style.left = progressLeft + 'px';
      }
      return this.isScrollEnd; 
    } else {
      return true; 
    }
  }

  requestAnimationFrameScroll = () => {
    const isScrollEnd = this.getScrollPosition();
    // 处理实时滚动位置的逻辑
    if (!isScrollEnd) {
      this.scrollAnimation = requestAnimationFrame(this.requestAnimationFrameScroll);
    } else {
      // 滚动到底了
      cancelAnimationFrame(this.scrollAnimation);
      this.scrollAnimation = null;
      this.goodsScrollRef.style.animationPlayState = 'paused';
      this.goodsBodyRef.scrollTo({
        top: 0,
        left: this.goodsScrollRef.clientWidth - window.screen.width
      });
      this.goodsScrollRef.style.animation = 'none';
    }
  };

  getAnimationDuration = () => {
    const duration = this.goodsScrollRef.clientWidth / (1316 / 40);
    return parseInt(duration);
  }

  getIfNewUser = (params) => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/activity/cate_new_status',
      method: "get",
      withCredentials: true,
      params: params,
    }).then(res => {
      const { status, data = {} } = res.data;
      if (status === 0) {
        this.setState({
          isCateNewUser: data.cate_new_user
        })
      }
    })
  }

  // 数据源分页加载
  dataSourcePageLoad = (page = 1) => {
    let { baseConfig, cardBaseConfig } = this.props.config;
    const { isLastComponent = false } = this.props;
    const { searchId, totalNum } = this.dataSourceConfig.dataConfig;
    const params = {
      page: page,
      search_id: searchId
    }
    if (!isLastComponent) {
      Object.assign(params, {
        page_size: totalNum
      });
    }

    const productStyle = baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle);
    let firstPageNum = 0, addBaseNum = 0;
    if (productStyle === '一行一个') {
      firstPageNum = 6;
      addBaseNum = 20;
    } else if (productStyle === '一行两个') {
      firstPageNum = 6;
      addBaseNum = 40;
    } else if (productStyle === '一行三个') {
      firstPageNum = 12;
      addBaseNum = 60;
    } else {
      firstPageNum = 0;
      addBaseNum = 0;
    }

    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/lego_data/page_list',
      method: "get",
      withCredentials: true,
      params: params,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        if (data.list && data.list.length > 0) {
          const originalData = data.list;
          const list = this.componentFieldsMap(originalData);
          if (this.page <= 1) {
            this.setState({
              productList: list,
              visiable: true,
              pageSize: Math.ceil((list.length - firstPageNum) / addBaseNum) + 1
            }, () => {
              if (this.state.productList.length > 0 && productStyle === '多个商品，自动适配') {
                this.onScrollLayoutRow()
              }
            }); 
          } else {
            const listAll = [...this.state.productList, ...list];
            this.setState({
              productList: listAll,
              visiable: true,
              pageSize: Math.ceil((listAll.length - firstPageNum) / addBaseNum) + 1
            }, () => {
              if (this.state.productList.length > 0 && productStyle === '多个商品，自动适配') {
                this.onScrollLayoutRow()
              }
            }); 
          }
          this.isLoading = false
        } else {
          this.hasNext = false
        }
      }
    })
  }

  // 数据源字段与组件字段映射匹配
  componentFieldsMap = (dataSource = []) => {
    const fieldMap = this.fieldMap || [];
    const mapResult = [];
    dataSource.length > 0 && dataSource.forEach((item, index) => {
      mapResult[index] = {
        id: '',
        name: '',
        useCustomName: false,
        recommendType: '推荐理由',
        recommend: '',
        shoppersLabel: '单位价格',
        shoppersLabelText: '',
        productImageCustom: '',
        markIconCustom: '',
        actionButtonCustom: '',
      };
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          const findKey = this.findKey(this.fieldMapTable, key);
          if (findKey) {
            mapResult[index][findKey] = item[key];
            if (findKey === 'sell_point') {
              let sell_point_str = '';
              if (item[key] > 9999) {
                sell_point_str = item[key] / 10000;
                sell_point_str = (Math.floor(sell_point_str * 10 ) / 10) + 'w';
              } else {
                sell_point_str = String(item[key]);
              }
              mapResult[index]['sell_point_str'] = sell_point_str;
            }
            if (this.formType === 'goods') {
              mapResult[index]['title'] = item['goods_name']
            } else {
              mapResult[index]['title'] = `${item['goods_name']} ${item['style_name']}` 
            }
          }
        }
      }
    });
    return mapResult;
  }

  getProductListData() {
    let itemList = {};
    let { baseConfig, cardBaseConfig } = this.props.config;
    let productType = baseConfig.productType || (cardBaseConfig && cardBaseConfig.productType);
    const sortType = baseConfig.sortType || (cardBaseConfig && cardBaseConfig.sortType);
    const dateRange = cardBaseConfig.dateRange;
    const shihuoSubsidy = baseConfig.shihuoSubsidy || (cardBaseConfig && cardBaseConfig.shihuoSubsidy);
    const productStyle = baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle);

    if (sortType === '自定义排序') {
      itemList = JSON.parse(JSON.stringify(this.initList))
    } else {
      itemList = this.props.config.itemList;
    }
    const itemDataObj = {};
    const idList = itemList.map((item) => {
      if (item.id) {
        itemDataObj[item.id] = item;
      }
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "", firstPageNum = 0, addBaseNum = 0;

    if (productStyle === '一行一个') {
      firstPageNum = 6;
      addBaseNum = 20;
    } else if (productStyle === '一行两个') {
      firstPageNum = 6;
      addBaseNum = 40;
    } else if (productStyle === '一行三个') {
      firstPageNum = 12;
      addBaseNum = 60;
    } else {
      firstPageNum = 0;
      addBaseNum = 0;
    }

    if (productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "配色id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "skuId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";
    }

    let sort_tag = 0;
    if (sortType === '销量') {
      if (!dateRange || dateRange === '默认') {
        sort_tag = 4
      } else {
        sort_tag = this.saleTypeMap[dateRange]
      }
    } else {
      sort_tag = this.sortTypeMap[sortType]
    }
    Request({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: sort_tag,
        filter_subsidy: shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.List;
        const notFoundList = res.data.data.NotFound || [];
        if (sortType === '自定义排序') {
          itemList.forEach((item, index) => {
            if (item.id == '0') {
              // 无渠道商品，插入列表中
              const element = {
                id: item.id,
                image: item.productImageCustom,
                price: item.productPrice,
                title: item.name,
                url: item.productHref,
                useCustomName: item.useCustomName,
                title: item.name,
                recommendType: item.recommendType,
                shoppersLabel: item.shoppersLabel,
                recommend: item.recommend,
                pocket: '超值好物',
                custom_unitPrice: item.shoppersLabelText,
                image: item.productImageCustom,
                markIcon: item.markIconCustom || cardBaseConfig.markIcon,
                custom_actionButton: item.actionButtonCustom,
              }
              list.splice(index, 0, element)
            }
          });
          // 插入定制化内容
          let rectImgs = 0, showRectImg = false;
          itemList.forEach((product) => {
            try {
              const customItem = list.find((item) => item.id == product.id);
              if (cardBaseConfig.sortType === '销量') {
                switch (cardBaseConfig.dateRange) {
                  case '近1天':
                    customItem.sell_point = customItem.realSaleNum;
                    customItem.sell_point_str = String(customItem.realSaleNum);
                    break;
                  case '近7天':
                    customItem.sell_point = customItem.realSaleNum7;
                    customItem.sell_point_str = String(customItem.realSaleNum7);
                    break;
                  case '近14天':
                    customItem.sell_point = customItem.realSaleNum14;
                    customItem.sell_point_str = String(customItem.realSaleNum14);
                    break;
                  case '近30天':
                    customItem.sell_point = customItem.realSaleNum30;
                    customItem.sell_point_str = String(customItem.realSaleNum30);
                    break;
                  default:
                    break;
                }
              }
              if (customItem && customItem.id != '0') {
                Object.assign(product, {
                  ...customItem,
                  image: productType !== '商品id' ? ((product.image && product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2') < 0) ? product.image : customItem.image) : customItem.image,
                  title: product.useCustomName ? product.name : customItem.title,
                  price: productType !== '商品id' ? (product.productPrice || customItem.price) : customItem.price,
                  recommend: product.recommendType === '自定义' ? (product.recommend) : (customItem.recommend),
                  markIcon: product.markIconCustom || cardBaseConfig.markIcon,
                  custom_actionButton: product.actionButtonCustom,
                  url: product.productHref || customItem.url,
                  custom_unitPrice: product.shoppersLabel === '自定义' ? product.shoppersLabelText : customItem.unit_price_text,
                  pocket: '超值好物'
                })
              }
              if (product.rectImg) {
                rectImgs++;
              }
            } catch (error) {
              const customItem_beta = itemDataObj[product.id];
              if (customItem_beta) {
                product.useCustomName = customItem_beta.useCustomName;
                product.title = customItem_beta.name;
                product.recommend = customItem_beta.recommend;
              }
            }
          });
          if (cardBaseConfig.showRectImg === '是' && rectImgs == itemList.length) {
            showRectImg = true;
          }
          if (notFoundList.length > 0) {
            // 删除 notFoundList 中存在的商品
            itemList = itemList.filter(product => {
              const notFound = notFoundList.find(item => item == product.id);
              return notFound ? false : true
            });
          }
          this.setState({
            visiable: true,
            showRectImg: showRectImg,
            productList: itemList,
            pageSize: Math.ceil((itemList.length - firstPageNum) / addBaseNum) + 1
          }, () => {
            if (this.state.productList.length > 0 && productStyle === '多个商品，自动适配') {
              this.onScrollLayoutRow()
            }
          });
        } else {
          // 非自定义排序，以实时抓取的数据顺序展示
          itemList.forEach((item, index) => {
            if (item.id == '0') {
              // 无渠道商品，插入列表中
              const element = {
                id: item.id,
                image: item.productImageCustom,
                price: item.productPrice,
                title: item.name,
                url: item.productHref,
                useCustomName: item.useCustomName,
                title: item.name,
                recommendType: item.recommendType,
                shoppersLabel: item.shoppersLabel,
                recommend: item.recommend,
                pocket: '超值好物',
                custom_unitPrice: item.shoppersLabelText,
                image: item.productImageCustom,
                markIcon: item.markIconCustom || cardBaseConfig.markIcon,
                custom_actionButton: item.actionButtonCustom,
              }
              list.splice(index, 0, element)
            }
          });
          // 插入定制化内容
          let rectImgs = 0, showRectImg = false;
          list.forEach((product) => {
            if (cardBaseConfig.sortType === '销量') {
              switch (cardBaseConfig.dateRange) {
                case '近1天':
                  product.sell_point = product.realSaleNum;
                  product.sell_point_str = String(product.realSaleNum);
                  break;
                case '近7天':
                  product.sell_point = product.realSaleNum7;
                  product.sell_point_str = String(product.realSaleNum7);
                  break;
                case '近14天':
                  product.sell_point = product.realSaleNum14;
                  product.sell_point_str = String(product.realSaleNum14);
                  break;
                case '近30天':
                  product.sell_point = product.realSaleNum30;
                  product.sell_point_str = String(product.realSaleNum30);
                  break;
                default:
                  break;
              }
            }
            try {
              const customItem = itemList.find((item) => item.id == product.id);
              if (customItem && customItem.id != '0') {
                product.useCustomName = customItem.useCustomName;
                product.recommendType = customItem.recommendType;
                product.shoppersLabel = customItem.shoppersLabel;
                product.custom_unitPrice = customItem.shoppersLabelText;
                product.markIcon = customItem.markIconCustom || cardBaseConfig.markIcon;
                product.custom_actionButton = customItem.actionButtonCustom;
                product.title = customItem.useCustomName ? customItem.name : product.title;
                product.recommend = customItem.recommendType === '自定义' ? (customItem.recommend) : (product.recommend);
                product.pocket = '超值好物';
                // 商品维度，商品图片、价格、跳转地址均要实时获取
                if (productType !== '商品id') {
                  product.url = customItem.productHref || product.url;
                  product.price = customItem.productPrice || product.price;
                  product.image = customItem.productImageCustom || product.image;
                }
              }
              if (product.rectImg) {
                rectImgs++;
              }
            } catch (error) {
              console.log('商品组件数据遍历错误');
              const customItem_beta = itemDataObj[product.id];
              if (customItem_beta) {
                product.useCustomName = customItem_beta.useCustomName;
                product.title = customItem_beta.name;
                product.recommend = customItem_beta.recommend;
              }
            }
          });
          if (cardBaseConfig.showRectImg === '是' && rectImgs == list.length) {
            showRectImg = true;
          }
          this.setState({
            visiable: true,
            productList: list,
            showRectImg: showRectImg,
            pageSize: Math.ceil((list.length - firstPageNum) / addBaseNum) + 1
          }, () => {
            if (this.state.productList.length > 0 && productStyle === '多个商品，自动适配') {
              this.onScrollLayoutRow()
            }
          });
        }

        this.isLoading = false;
      }
    });
  }

  findKey (obj,value, compare = (a, b) => a === b) {
    return Object.keys(obj).find(k => compare(obj[k], value))
  }

  getProductCollectionData() {
    const { baseConfig, cardBaseConfig, itemCollectionList } = this.props.config;
    const itemList = itemCollectionList || [];
    const collectionIdList = [];
    const productType = baseConfig.productType || (cardBaseConfig && cardBaseConfig.productType);
    const productStyle = baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle);
    itemList.forEach((item) => {
      if (item.id) {
        collectionIdList.push({
          id: Number(item.id),
          limit: isNaN(item.limit) ? 20 : Number(item.limit),
          source: productType === '商品集合id' ? 1 : 2,
        });
      }
    });

    let firstPageNum = 0, addBaseNum = 0;
    if (productStyle === '一行一个') {
      firstPageNum = 6;
      addBaseNum = 20;
    } else if (productStyle === '一行两个') {
      firstPageNum = 6;
      addBaseNum = 40;
    } else if (productStyle === '一行三个') {
      firstPageNum = 12;
      addBaseNum = 60;
    } else {
      firstPageNum = 0;
      addBaseNum = 0;
    }
    
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-goodssetapi/set/lego?token=7a08a813-faf1-03e5-d547-cf6bdd1c9ddb&client_name=theme',
      method: "post",
      withCredentials: true,
      data: {
        idList: collectionIdList,
      },
    }).then((collectionRes) => {
      if (collectionRes.data.status === 0) {
        const collectionList = collectionRes.data.data || [];
        const productIdList = [];
        let reqUrl;
        if (productType === "商品集合id") {
          reqUrl =
            "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
            collectionList.forEach(collectionItem => {
            const list = collectionItem.list || [];
            list.forEach(item => {
              const id = item.goods_id;
              if (!productIdList.includes(id)) {
                productIdList.push(id);
              }
            })
          });
        } else if (productType === "配色集合id") {
          reqUrl =
            "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
            collectionList.forEach(collectionItem => {
              const list = collectionItem.list || [];
              list.forEach(item => {
                const id = item.style_id;
                if (!productIdList.includes(id)) {
                  productIdList.push(id);
                }
              })
            });
        }

        const sortType = baseConfig.sortType || (cardBaseConfig && cardBaseConfig.sortType);
        const shihuoSubsidy = baseConfig.shihuoSubsidy || (cardBaseConfig && cardBaseConfig.shihuoSubsidy);
    
        Request({
          url: reqUrl,
          method: "post",
          withCredentials: true,
          data: {
            ids: productIdList,
            sort_tag: this.sortTypeMap[sortType] || 0,
            filter_subsidy: shihuoSubsidy === '是' ? 1 : 0,
            from: this.props.specialApiFrom
          },
        }).then((res) => {
          if (res.data.status === 0) {
            const list = res.data.data.List;
            // 插入定制化内容
            list.forEach((product) => {
              product.useCustomName = false;
              product.custom_title = product.name;
              product.custom_recommend = product.recommend;
            });
            this.setState({
              visiable: true,
              productList: list,
              pageSize: Math.ceil((list.length - firstPageNum) / addBaseNum) + 1
            }, () => {
              if (this.state.productList.length > 0 && productStyle === '多个商品，自动适配') {
                this.onScrollLayoutRow()
              }
            });
          }
        });
      }
    });
  }

  //判断版本号
  appVersion() {
    return  utils.SHDiffVersion(utils.getVersion(), '7.28.0')// 前面版本号大
  }

  linkClick() {
    const { isCateNewUser, selectedItem, selectetIndex } = this.state
    if ((isCateNewUser && !this.appVersion())) {
      if(utils.isAndroid()) {
        window.location.href = 'https://www.shihuo.cn/app3/download'
      } else {
        window.location.href = 'itms-apps://itunes.apple.com/app/id875177200?mt=8'
      }
      // window.Jockey.send("action", {
      //   url: "https://www.shihuo.cn/webview/upgrade?v=2.2#",
      // });
    } else {
      if (this.countDownInterVal) {
        clearInterval(this.countDownInterVal);
        this.countDownInterVal = null;
        this.setState({
          mask_show: false,
          noticeVersionShow: false,
          backCount: 3
        })
      }
      this.handleItemClick(selectedItem, selectetIndex)
    }
  }
  //新人类目价
  handleItemPerNewUserClick(item, index) {
    const { isCateNewUser } = this.state
    const { cardInfoConfig = {} } = this.formatProductData(this.props.config)
    if (cardInfoConfig.newUserPrice === '新人价') {
      if (!isCateNewUser || (isCateNewUser && !this.appVersion())) {
        this.setState({
          mask_show: true,
          noticeVersionShow: true,
          selectedItem: item,
          selectetIndex: index,
          // backCount: 3
        })
      if (!isCateNewUser) {
        clearInterval(this.countDownInterVal);
        this.countDownInterVal = setInterval(() => {
          if (this.state.backCount <= 1) {
            clearInterval(this.countDownInterVal);
            this.countDownInterVal = null;
            this.setState({
              mask_show: false,
              noticeVersionShow: false,
              backCount: 3
            })
            this.handleItemClick(item, index)
          } else {
            this.setState({
              backCount: this.state.backCount - 1
            });
          }
        }, 1000);
      }
      } else {
        this.handleItemClick(item, index)
      }
    } else {
      this.handleItemClick(item, index)
    }
   
    
  }

  // 关闭弹窗
  closeNewUserDialog() {
    if (this.countDownInterVal) {
      clearInterval(this.countDownInterVal);
      this.countDownInterVal = null;
    }
    this.setState({
      mask_show: false,
      noticeVersionShow: false,
      backCount: 3
    })
  }

  getTrackData(item, index) {
    const { baseConfig, cardBaseConfig } = this.props.config;
    const options = {
      title: baseConfig.title,
      type: baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle),
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id" || (cardBaseConfig && cardBaseConfig.productType === "商品id")) {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    return options;
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }
    const options = this.getTrackData(item, index);
    const convertUrl = utils.convertHref(item.url); 
    utils.jumpToUrl(this.props.routeParams, convertUrl, convertUrl, options, item.id, this.props);
  }

  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    // 商品banner跳转
    if (url) {
      const options = {};
      const convertUrl = utils.convertHref(url);
      utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false); 
    }
  };

  handleExpandMore = () => {
    const { showPage, pageSize } = this.state;
    if (showPage === 1) {
      // 记录初识点击展开时页面的滚动位置
      this.currentPosition = document.documentElement.scrollTop;
    }

    if (showPage + 1 > pageSize) {
      // 收起时回到最初记录的位置
      window.scrollTo(0, this.currentPosition);
    }
    
    this.setState({
      showPage: showPage + 1 > pageSize ? 1 : showPage + 1
    });
  }

  // 因商品组件优化，调整了schema结构并增加了配置项，这里对老的商品组件数据进行格式化
  formatProductData(dataSource) {
    if (dataSource.cardBaseConfig) {
      if ((dataSource.cardInfoConfig && !dataSource.cardInfoConfig.priority) || (dataSource.promotionCardInfoConfig && !dataSource.promotionCardInfoConfig.priority)) {
        const { baseConfig = {}, cardBaseConfig = {}, cardInfoConfig = {}, promotionCardInfoConfig = {}, itemList = [], itemCollectionList = [], componentSize ={} } = dataSource;
        const result = {
          baseConfig,
          cardBaseConfig,
          cardInfoConfig: {
            priceInfo: cardInfoConfig.priceInfo,
            saleNum: "销量",
            newUserPrice: "无",
            benefitLabel: "",
            slogen: cardInfoConfig.slogen,
            unitPrice: cardInfoConfig.unitPrice,
            priority: "优先展示推荐理由"
          },
          promotionCardInfoConfig: {
            priceInfo: promotionCardInfoConfig.priceInfo,
            saleNum: "销量",
            benefitLabel: "",
            slogen: promotionCardInfoConfig.slogen,
            unitPrice: promotionCardInfoConfig.unitPrice,
            benefit: promotionCardInfoConfig.benefit,
            priority: "优先展示推荐理由"
          },
          itemList,
          itemCollectionList,
          componentSize
        }
        
        for (const key in cardInfoConfig) {
          if (Object.hasOwnProperty.call(cardInfoConfig, key)) {
            const value = cardInfoConfig[key];
            if (key === 'originPrice' && typeof value === 'boolean') {
              if (value) {
                result.cardInfoConfig.priceInfo = '原价'
              }
            } else if (key === 'discount' && typeof value === 'boolean') {
              if (value) {
                result.cardInfoConfig.priceInfo = '折扣'
              }
            } else if (key === 'saleNum' && typeof value === 'boolean') {
              if (value) {
                if (cardBaseConfig.productStyle !== '多个商品，自动适配') {
                  result.cardInfoConfig.saleNum = '销量'
                } else {
                  result.cardInfoConfig.priceInfo === '销量'
                }
              } else {
                if (cardBaseConfig.productStyle !== '多个商品，自动适配') {
                  result.cardInfoConfig.saleNum = '无'
                }
              }
            } else if (key === 'newUserPrice' && typeof value === 'boolean') {
              result.cardInfoConfig.newUserPrice = value ? '新人价' : '无'
            }
          }
        }

        for (const key in promotionCardInfoConfig) {
          if (Object.hasOwnProperty.call(promotionCardInfoConfig, key)) {
            const value = promotionCardInfoConfig[key];
            if (key === 'saleNum' && typeof value === 'boolean') {
              result.promotionCardInfoConfig.saleNum = value ? '销量' : '无'
            }
          }
        }
        if (typeof promotionCardInfoConfig.saleNum === 'boolean') {
          result.promotionCardInfoConfig.saleNum = promotionCardInfoConfig.saleNum === true ? '销量' : '无'
        }

        return result;
      }
      return dataSource;
    };
    const { baseConfig, componentSize, itemCollectionList, itemList } = dataSource;
    const result = {
      baseConfig: {
        showTitle: baseConfig.showTitle,
        showSubTitle: baseConfig.showSubTitle,
        addToNav: baseConfig.addToNav,
        showFoldBtn: false,
        title: baseConfig.title,
        subTitle: baseConfig.subTitle,
        titleColor: baseConfig.titleColor,
        priceColor: "",
        priceInfoColor: ""
      },
      cardBaseConfig: {
        productStyle: baseConfig.productStyle,
        layout_1: baseConfig.layout_1,
        layout_2: baseConfig.layout_2,
        layout_3: baseConfig.layout_3,
        layout_row: baseConfig.layout_row,
        layout_adapt: {},
        productType: baseConfig.productType,
        sortType: baseConfig.sortType,
        shihuoSubsidy: baseConfig.shihuoSubsidy,
        imgUrl: baseConfig.imgUrl,
        imgLink: baseConfig.imgLink,
        priceIcon: baseConfig.priceIcon,
        productNameColor: "#333",
        productTagColor: "#C28A58",
        cardBackground: "",
        actionButton: ""
      },
      cardInfoConfig: {
        originPrice: baseConfig.originPrice,
        discount: baseConfig.discount,
        saleNum: baseConfig.saleNum,
        markIcon: false,
        actionButton: false,
        slogen: baseConfig.slogen,
        unitPrice: baseConfig.unitPrice
      },
      componentSize,
      itemCollectionList,
      itemList,
    }
    return result;
  }

  getDiscount = (price, original_price) => {
    let discountRate = price / original_price;
    if (discountRate > 1 || isNaN(discountRate) || original_price === 0) {
      discountRate = 1;
    }
    discountRate = discountRate * 10;
    discountRate = parseFloat(discountRate.toFixed(1));
    return discountRate < 10 ? `${discountRate}折` : '';
  }

  getClassRowColumn = (className, rowItemNumber, length, index) => {
    const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
    const totalRowNum = Math.ceil(length / rowItemNumber);
    const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
    const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
    const isFirstColumn = Boolean(index % rowItemNumber === 0);
    const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列
    if (isFirstRow) {
      className += ' first-row';
    }
    if (isLasthRow) {
      className += ' lasth-row';
    }
    if (isFirstColumn) {
      className += ' first-column';
    }
    if (isLastColumn) {
      className += ' last-column';
    }
    return className;
  }

  render() {
    let { showPage, pageSize, visiable, mask_show, noticeVersionShow, backCount, isCateNewUser } = this.state;
    const { baseConfig, cardBaseConfig } = this.formatProductData(this.props.config);

    if (cardBaseConfig.productStyle === "一行一个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_1);
    } else if (cardBaseConfig.productStyle === "一行两个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
    } else if (cardBaseConfig.productStyle === "一行三个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_3);
    } else if (cardBaseConfig.productStyle === "一行一排") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_row);
    } else if (cardBaseConfig.productStyle === "多个商品，自动适配") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_adapt);
    }

    if (!visiable) {
      return (
        <div
          ref={ref => this.pipelineProductRef = ref}
          className="pipeline-product"
          id={this.props['customAttributes']['data-component-id']}
          name={baseConfig.title}
          {...this.props['customAttributes']}
          style={{
            paddingTop: cardBaseConfig.moduleMarginTop >= 0 ? `${cardBaseConfig.moduleMarginTop}px` : '0px',
            marginTop: cardBaseConfig.moduleMarginTop < 0 ? `${cardBaseConfig.moduleMarginTop}px` : '0px',
            marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
          }}
        >
        </div>
      );
    }

    let renderProduct = null;
    switch (cardBaseConfig.productCardType) {
      case '常规样式':
        renderProduct = this.renderNormalType()
        break;
      case '促销样式':
        renderProduct = this.renderPromotionType()
        break;
      case '主题促销样式':
        renderProduct = this.renderThemeSaleType()
        break;
      default:
        renderProduct = this.renderNormalType()
        break;
    }

    const { width, height } = utils.getAdaptImageSize(cardBaseConfig.titleImageSize);

    return (
      <div
        ref={ref => this.pipelineProductRef = ref}
        className="pipeline-product"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: cardBaseConfig.moduleMarginTop >= 0 ? `${cardBaseConfig.moduleMarginTop}px` : '0px',
          marginTop: cardBaseConfig.moduleMarginTop < 0 ? `${cardBaseConfig.moduleMarginTop}px` : '0px',
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
        }}
      >
        {
          ((baseConfig.showTitle && baseConfig.title) || (baseConfig.showSubTitle && baseConfig.subTitle)) && cardBaseConfig.productStyle !== "一行一排" &&  cardBaseConfig.productStyle !== "多个商品，自动适配" && (
            <div className="title-area">
              {baseConfig.showTitle && baseConfig.title && ['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0 && (
                <div className="title" style={{ color: baseConfig.titleColor }}>
                  {baseConfig.title.slice(0, 16)}
                </div>
              )}
              {baseConfig.showSubTitle && baseConfig.subTitle && ['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0 && (
                <div
                  className="sub-title"
                  style={{ color: baseConfig.titleColor }}
                  dangerouslySetInnerHTML={{ __html: baseConfig.subTitle }}
                />
              )}
            </div>
          )
        }
        {cardBaseConfig.imgUrl && ['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0 && (
          <img
            className="product-banner"
            onClick={this.productBannerGo.bind(this, cardBaseConfig.imgLink)}
            src={utils.formatImgUrl(cardBaseConfig.imgUrl, this.props.webpSupport)}
            alt=""
            style={{
              width,
              height
            }}
          />
        )}
        { renderProduct }
        {
          baseConfig.showFoldBtn && (
            <div className="fold-btn" style={{color: baseConfig.titleColor, borderColor: baseConfig.titleColor ? this.hexColorToRgba(baseConfig.titleColor, 0.8) : baseConfig.titleColor}} onClick={() => this.handleExpandMore()}>
              {showPage >= pageSize ? '收起' : '展开更多'}
              {
                showPage >= pageSize ? (
                  <svg t="1664182775303" className="icon up" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2222"><path d="M169.344 694.656a32 32 0 0 0 40.832 3.648l4.48-3.648L512 397.248l297.344 297.408a32 32 0 0 0 40.832 3.648l4.48-3.648a32 32 0 0 0 3.648-40.832l-3.648-4.48-320-320a32 32 0 0 0-40.832-3.648l-4.48 3.648-320 320a32 32 0 0 0 0 45.312z" p-id="2223" fill={baseConfig.titleColor}></path></svg>
                ) : (
                  <svg t="1664182701343" className="icon down" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2002"><path d="M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z" p-id="2003" fill={baseConfig.titleColor}></path></svg>
                )
              }
            </div>
          )
        }
        { mask_show && <div className="pipeline-product-mask"></div> }
        {
          noticeVersionShow && (
            <div className={["pipeline-product-notice-version", `${!isCateNewUser ? "pipeline-product-notice-version2" : null}`].join(" ")}>
              <div className="pipeline-product-notice-version-title">{!isCateNewUser ? `活动仅限${window.classifyName}新用户`:'当前版本过低'}</div>
              {!isCateNewUser ? 
                 <div className="pipeline-product-notice-version-content">
                    <div>抱歉，你无法享受新人价</div>
                    <div>可继续查看全网底价</div>
                 </div> :
                 <div className="pipeline-product-notice-version-content">请升级最新版本，享受补贴</div>
              }
              <div className="pipeline-product-notice-version-button" onClick={this.linkClick.bind(this)}>{!isCateNewUser ? `去查看（${backCount}s）` : '去升级'}</div>
              <img
                  src="https://static.shihuocdn.cn/admin/files/20221226/ceab8c8de1a6373675898799f28e1e0d.png"
                  alt=""
                  className="pipeline-product-notice-version-close"
                  onClick={this.closeNewUserDialog.bind(this)}
                />
            </div>
          )
         
        }
      </div>
    );
  }

  rederSparePriceView (baseConfig, price, type, unitPriceReplacePrice = false) {
    let sparePrice = null
    if (price > 1000) {
      sparePrice = utils.priceConversion(price, 2);
    }

    if(sparePrice && sparePrice.list) {
      const typeSize = {
        1 : {
         symbol: '12px',
         price: '18px',
         decimal: '13px',
        },
        2 : {
         symbol: '11px',
         price: '16px',
         decimal: '12px',
        },
        3 : {
         symbol: '10px',
         price: '15px',
         decimal: '11px',
        }
      }
      let sparePriceList = sparePrice.list
      this.renderPriceLength = sparePriceList[0].length + (sparePriceList[1] ? sparePriceList[1].length : 0)
      return (
        <div className="price" style={{color: baseConfig.priceColor}}>
          <span 
          style={{
            fontSize: px2rem(typeSize[type].symbol),
            marginBottom: px2rem('2px')
          }}
          >¥</span>
          <span 
            style={{
              fontSize: px2rem(typeSize[type].price),
            }}
          >{sparePriceList[0]}</span>
          {
            sparePriceList[1] &&  (
            <span 
              style={{
                fontSize: px2rem(typeSize[type].decimal),
                marginBottom: px2rem('2px'),
              }}
            >.{sparePriceList[1]}</span>
          )}
          {
            sparePrice.unit && (
              <span 
                style={{
                  fontSize: px2rem(typeSize[type].symbol),
                  marginBottom: px2rem('2px')
                }}
              >{sparePrice.unit}</span>
          )}
        </div>
      )
    } else {
      this.renderPriceLength = 0
      const priceStyle = {
        color: baseConfig.priceColor
      }
      const rmbStyle = {}
      if (unitPriceReplacePrice) {
        priceStyle.fontSize = px2rem('16px')
        rmbStyle.fontSize = px2rem('11px')
      }
      return (
        <div
          className="price"
          style={priceStyle}>
          <span
            className="rmb-icon"
            style={rmbStyle}
          >
            ¥
          </span>
          {price}
        </div>
      )
    }
  }

  rederSparePriceOneLineView (baseConfig, price) {
    let sparePrice = null
    if (price > 1000) {
      sparePrice = utils.priceConversion(price, 2);
    }
     if(sparePrice && sparePrice.list) {
      let sparePriceList = sparePrice.list
      this.renderPriceLength = sparePriceList[0].length + (sparePriceList[1] ? sparePriceList[1].length : 0)
      let pricefontSize = '12px'
      if (sparePriceList[0] > 100) {
        pricefontSize = '11px'
      }
      return (
        <div className="goods-item-price" style={{color: baseConfig.priceColor}}>
          <span 
          style={{
            fontSize: px2rem(pricefontSize),
          }}
          >¥</span>
          <span 
            style={{
              fontSize: px2rem(pricefontSize),
            }}
          >{sparePriceList[0]}</span>
          {
            sparePriceList[1] && (
              <span 
            style={{
              fontSize: px2rem(pricefontSize),
            }}
          >.{sparePriceList[1]}</span>
          )} 
          {
            sparePrice.unit && (
              <span 
              style={{
                fontSize: px2rem(pricefontSize)
              }}
            >{sparePrice.unit}</span>
          )}
        </div>
      )
     } else {
      this.renderPriceLength = 0
      return (
        <div className="goods-item-price" style={{color: baseConfig.priceColor}}>
          <span className='rmb-icon'>¥</span>
          <p className={String(parseFloat(price)).length > 5 ? 'long' : 'small'}>{price && parseFloat(price)}</p>
        </div>
      )
     }
  }

  renderPromotionSparePriceView (price, type) {
    let sparePrice = null
    if (price > 1000) {
      sparePrice = utils.priceConversion(price, 2);
    }
     if(sparePrice && sparePrice.list) {
      let sparePriceList = sparePrice.list
      const smallSize = sparePriceList[0] > 100 && sparePrice.unit && sparePriceList.length > 1 
      const minSize = sparePriceList[0] > 1000 && sparePrice.unit  && sparePriceList.length > 1 
       let typeSize = {
         1 : {
          symbol: '12px',
          price: '18px',
          decimal: '13px',
         },
         2 : {
          symbol: smallSize ? '10px': '10px',
          price: smallSize ? '10px':'15px',
          decimal: smallSize ? '10px':'11px',
         },
         3 : {
          symbol:minSize ? '8px': (smallSize ? '9px': '10px'),
          price: minSize ? '8px': (smallSize ? '9px': '10px'),
          decimal:minSize ? '8px': (smallSize ? '9px':'10px'),
         }
       }
      this.renderPriceLength = sparePriceList[0].length + (sparePriceList[1] ? sparePriceList[1].length : 0)
      return (
        <div className={'price small'}>
          <span 
          style={{
            fontSize: px2rem(typeSize[type].symbol || '8px'),
            marginBottom: px2rem('2px')
          }}
          >¥</span>
          <span 
            style={{
              fontSize: px2rem(typeSize[type].price || '8px'),
            }}
          >{sparePriceList[0]}</span>
          {
            sparePriceList[1] && (
              <span
                style={{
                  fontSize: px2rem(typeSize[type].decimal || '8px'),
                  marginBottom: px2rem('2px'),
                }}
              >.{sparePriceList[1]}</span>
            )}
          {
            sparePrice.unit && (
              <span
                style={{
                  fontSize: px2rem(typeSize[type].symbol || '8px'),
                  marginBottom: px2rem('2px')
                }}
              >{sparePrice.unit}</span>
            )}
        </div>
      )
     } else {
      this.renderPriceLength = 0
      return (
        <div className={String(parseFloat(price)).length >= 5 ? 'price large' : 'price small'}>
        <span className="rmb-icon">¥</span>
        <p className={String(parseFloat(price)).length >= 5 ? 'large' : 'small'}>{price}</p>
      </div>
      )
     }
  }

  renderPromotionSpareNewUserPriceView = (price, type) => {  
    let sparePrice = null
    if (price > 1000) {
      sparePrice = utils.priceConversion(price, 2);
    }

    if(sparePrice && sparePrice.list) {
      let sparePriceList = sparePrice.list
      const typeSize = {
        1 : {
          symbol: '12px',
          price: '18px',
          decimal: '13px',
        },
        2 : {
          symbol: '11px',
          price: '16px',
          decimal: '12px',
        },
        3 : {
         symbol: '10px',
         price: '10px',
         decimal: '10px',
        }
      }
     this.renderPriceLength = sparePriceList[0].length + (sparePriceList[1] ? sparePriceList[1].length : 0)
     return (
       <div className={'price'}>
         <span 
         style={{
           fontSize: px2rem(typeSize[type].symbol || '10px'),
           marginBottom: px2rem('2px')
         }}
         >¥</span>
         <span 
           style={{
             fontSize: px2rem(typeSize[type].price || '10px'),
           }}
         >{sparePriceList[0]}</span>
         {
           sparePriceList[1] && (
            <span 
            style={{
              fontSize: px2rem(typeSize[type].decimal || '10px'),
              marginBottom: px2rem('2px'),
            }}
          >.{sparePriceList[1]}</span>
         )}
         {
           sparePrice.unit && (
             <span
               style={{
                 fontSize: px2rem(typeSize[type].symbol || '10px'),
                 marginBottom: px2rem('2px')
               }}
             >{sparePrice.unit}</span>
          )}
       </div>
     )
    } else {
     this.renderPriceLength = 0
     return (
      <p className="price">
        <span className="rmb-icon">¥</span>
        {price}
      </p>
     )
    }
  }

  rederLayoutRowPromotionOneLineView (price, type) {
    let sparePrice = null
    if (price > 1000) {
      sparePrice = utils.priceConversion(price, 2);
    }

     if(sparePrice && sparePrice.list) {
      const smallSize = price > 1000000 && sparePrice.unit != '亿';
      let sparePriceList = sparePrice.list;
      this.renderPriceLength = sparePriceList[0].length + (sparePriceList[1] ? sparePriceList[1].length : 0)
      return (
        <div className="goods-item-price">
          <span 
          style={{
            fontSize: px2rem(smallSize ? '7px':'9px'),
          }}
          >¥</span>
          <span 
            style={{
              fontSize: px2rem(smallSize ? '7px' :'9px'),
            }}
          >{sparePriceList[0]}</span>
          {
            sparePriceList[1] &&  (
              <span
                style={{
                  fontSize: px2rem(smallSize ? '7px' : '9px'),
                }}
              >.{sparePriceList[1]}</span>
            )}
          {
            sparePrice.unit && (
              <span
                style={{
                  fontSize: px2rem(smallSize ? '7px' : '9px'),
                }}
              >{sparePrice.unit}</span>
            )}
        </div>
      )
     } else {
      this.renderPriceLength = 0
      if(type == 'new') {
       return (
          <div className={String(parseFloat(price)).length >= 5 ? 'goods-item-price large' : 'goods-item-price small'}>
            <span className='rmb-icon'>¥</span>
            <p className={String(parseFloat(price)).length >= 5 ? 'large' : 'small'}>{price && parseFloat(price)}</p>
          </div>
       )
      }
      return (
        <div className="goods-item-price">
          <span className='rmb-icon'>¥</span>
          <p className={String(parseFloat(price)).length >= 5 ? 'large' : 'small'}>{price && parseFloat(price)}</p>
        </div>
      )
     }
  }

  // 优先展示单位价
  renderPriceView(item, baseConfig, cardInfoConfig) {
    const { price, unit_price_text, custom_unitPrice, shoppersLabel } = item;
    const { unitPriceReplacePrice, newUserPrice } = cardInfoConfig;
    let priceView = null, showTotalPrice = true;
    if (unitPriceReplacePrice) {
      // 商品价格优先展示为单位价
      if (shoppersLabel === '单位价格') {
        priceView = this.rederSparePriceView(baseConfig, unit_price_text ? unit_price_text.replace('¥', '') : price, 1, true);
        showTotalPrice = Boolean(unit_price_text);
      } else {
        priceView = this.rederSparePriceView(baseConfig, custom_unitPrice ? custom_unitPrice.replace('¥', '') : price, 1, true);
        showTotalPrice = Boolean(custom_unitPrice);
      }
      return (
        <div className="unitPrice-priority">
          { priceView }
          { (showTotalPrice && price) && <span className="total-price">总价¥{price}</span> }
        </div>
      )
    } else {
      // 商品价格正常展示
      if ((price || price === 0) && (!newUserPrice || newUserPrice === '无')) {
        priceView =  this.rederSparePriceView(baseConfig, price, 1);
      } else {
        priceView = null;
      }
      return priceView;
    }
  }

  // 常规样式
  renderNormalType() {
    let { productList = [], showPage, showRectImg } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig = {} } = this.formatProductData(this.props.config);

    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
    // 判断不同布局方式下的间距取值
    if (cardBaseConfig.productStyle === "一行一个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_1);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 6) : productList.slice(0, 6 + 20 * (showPage - 1))) : productList;
    } else if (cardBaseConfig.productStyle === "一行两个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 6) : productList.slice(0, 6 + 40 * (showPage - 1))) : productList;
    } else if (cardBaseConfig.productStyle === "一行三个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_3);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 12) : productList.slice(0, 12 + 60 * (showPage - 1))) : productList;
    } else if (cardBaseConfig.productStyle === "一行一排") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_row);
      productList = productList;
    } else if (cardBaseConfig.productStyle === "多个商品，自动适配") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_adapt);
      productList = productList;
    }
    // 转为数字处理，后续参与计算
    cardBaseConfig.itemMargin = isNaN(Number(cardBaseConfig.itemMargin))
      ? 0
      : Number(cardBaseConfig.itemMargin);
    
    if (['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0) {
      return (
        <div className="product-list product-list-normal">
          {productList.map((item, index) => {
            let rowItemNumber = 3; // 每行排列数量
            if (cardBaseConfig.productStyle === "一行一个") {
              rowItemNumber = 1;
            } else if (cardBaseConfig.productStyle === "一行两个") {
              rowItemNumber = 2;
            } else if (cardBaseConfig.productStyle === "一行三个") {
              rowItemNumber = 3;
            }
  
            // 折扣计算
            let discountRate = item.price / item.original_price;
            if (
              discountRate > 1 ||
              isNaN(discountRate) ||
              item.original_price === 0
            ) {
              discountRate = 1;
            }
            discountRate = discountRate * 10;
            discountRate = parseFloat(discountRate.toFixed(1));
  
            // 行数计算
            const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
            const totalRowNum = Math.ceil(productList.length / rowItemNumber);
            const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
            const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列
  
            // 计算每个项的宽度
            const totalMargin = (rowItemNumber - 1) * cardBaseConfig.itemMargin;
            const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
            const itemStyle = {
              width: itemWidth,
              marginTop: isFirstRow ? "0" : `${cardBaseConfig.itemMargin / 2}px`,
              marginBottom: isLasthRow
                ? "0"
                : `${cardBaseConfig.itemMargin / 2}px`,
              marginLeft: isFirstColumn
                ? "0"
                : `${cardBaseConfig.itemMargin / 2}px`,
              marginRight: isLastColumn
                ? "0"
                : `${cardBaseConfig.itemMargin / 2}px`,
              backgroundColor: cardBaseConfig.cardBackgroundColor
            };
  
            if (!cardBaseConfig.cardBackgroundColor) {
              cardBaseConfig.cardBackground && Object.assign(itemStyle, {
                backgroundImage: `url(${cardBaseConfig.cardBackground})`,
                backgroundSize: "100% 100%",
                backgroundColor: "transparent",
                backgroundRepeat: "no-repeat",
                borderRadius: "inherit"
              })
            } else {
              Object.assign(itemStyle, {
                backgroundColor: cardBaseConfig.cardBackgroundColor
              })
            }
  
            let productItem;
            if (cardBaseConfig.productStyle === "一行一个") {
              // 三个展示都存在时，隐藏销量
              if (
                cardInfoConfig.priceInfo !== '无' &&
                cardInfoConfig.saleNum === '销量' &&
                cardInfoConfig.priceIcon
              ) {
                cardInfoConfig.saleNum = '无';
              }

              let labelOrRecommend = null;
              if (cardInfoConfig.slogen) {
                if (cardInfoConfig.priority === '优先展示标签') {
                  if ((item.labels && item.labels.length > 0)) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  } else {
                    labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend || item.pocket}</p>
                  }
                } else {
                  if (item.recommend) {
                    labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>
                  } else {
                    if (item.labels && item.labels.length > 0) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      labelOrRecommend = item.title && <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>
                    }
                  }
                }
              }

              const options = this.getTrackData(item, index);

              productItem = (
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                  className="product-item row-one-item"
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                >
                  <div className="product-img-panel">
                    <LazyLoadImage
                      width={px2rem('108px')}
                      height={px2rem('108px')}
                      effect="opacity"
                      placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 108, height: 108}}></span>}
                      src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                    />
                  </div>
                  <div className="product-info">
                    <div className="info">
                      <div
                        className={cardInfoConfig.slogen && (cardInfoConfig.unitPrice && !cardInfoConfig.unitPriceReplacePrice) ? "name line-clamp-1" : "name"}
                        style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor }}
                      >
                        {item.title}
                      </div>
                      {labelOrRecommend}
                      {(!cardInfoConfig.unitPriceReplacePrice && item.shoppersLabel === '单位价格' && cardInfoConfig.unitPrice && item.unit_price_text) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.unit_price_text}
                        </p>
                      )}
                      {(!cardInfoConfig.unitPriceReplacePrice && item.shoppersLabel === '自定义' && cardInfoConfig.unitPrice && item.custom_unitPrice) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.custom_unitPrice}
                        </p>
                      )}
                    </div>
                    <div className="sale">
                      <div className="price-container">
                        {cardBaseConfig.priceIcon && (
                          <img
                            className="price-icon"
                            src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                          />
                        )}
                        {
                          this.renderPriceView(item, baseConfig, cardInfoConfig)
                        }
                        {
                          cardInfoConfig.newUserPrice === '新人价' && (
                            this.rederSparePriceView(baseConfig, item.new_user_price || item.price, 1)
                          )
                        }
                        {cardInfoConfig.priceInfo === '原价' &&
                          item.original_price > item.price &&
                          item.original_price > 0 && (
                            <span className="origin-price" style={{color: baseConfig.priceInfoColor}}>
                              ¥{item.original_price}
                            </span>
                        )}
                        {cardInfoConfig.priceInfo === '折扣' && discountRate != 10 && (
                          <div className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</div>
                        )}
                      </div>
                      {cardInfoConfig.saleNum === '销量' && item.id && item.sell_point > 0 && (
                        <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                      )}
                    </div>
                  </div>
                  { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  {
                    (item.custom_actionButton || cardBaseConfig.actionButton) && (
                      <img className="action-button" src={utils.formatImgUrl(item.custom_actionButton || cardBaseConfig.actionButton, this.props.webpSupport, 'card')} />
                    )
                  }
                </div>
              );
            } else if (cardBaseConfig.productStyle === "一行两个") {
              // 四个展示都存在是，隐藏销量
              if (
                cardInfoConfig.priceInfo !== '无' &&
                cardInfoConfig.saleNum === '销量' &&
                cardBaseConfig.priceIcon
              ) {
                cardInfoConfig.saleNum = '无';
              }
              // 计算一行二商品图片宽度
              const productImgWidth = (bodyWidth - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)) / 2 - 8;

              let itemClass = 'product-item row-two-item';
              if (showRectImg) {
                itemClass += ' category-shoes'
              }
              if (cardInfoConfig.slogen || cardInfoConfig.unitPrice) {
                itemClass += ' has-benefit'
              } else {
                itemClass += ' no-benefit'
              }

              let labelOrRecommend = null;
              if (cardInfoConfig.slogen) {
                if (cardInfoConfig.priority === '优先展示标签') {
                  if ((item.labels && item.labels.length > 0)) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  } else {
                    labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend || item.pocket}</p>
                  }
                } else {
                  if (item.recommend) {
                    labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>
                  } else {
                    if (item.labels && item.labels.length > 0) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>
                    }
                  }
                }
              }

              const options = this.getTrackData(item, index);

              productItem = (
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                  className={itemClass}
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                >
                  <div className={showRectImg ? 'product-img-panel shoes' : 'product-img-panel'} style={{ marginTop: 4, marginBottom: 4, paddingLeft: 4, paddingRight: 4 }}>
                    <div className="img-wrap">
                      <LazyLoadImage
                        width={productImgWidth}
                        height={!showRectImg ? productImgWidth : ''}
                        className="img"
                        effect="opacity"
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                        src={utils.formatImgUrl(!showRectImg ? item.image : item.rectImg, this.props.webpSupport, 'card')}
                      />
                      {
                        item.beltImg && <img src={utils.formatImgUrl(item.beltImg, this.props.webpSupport, 'card')} alt="" className="beltImg" />
                      }
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="info">
                      <div
                        className={cardInfoConfig.slogen && cardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                        style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                      >
                        {item.title}
                      </div>
                      {labelOrRecommend}
                      {(item.shoppersLabel === '单位价格' && cardInfoConfig.unitPrice && item.unit_price_text) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.unit_price_text}
                        </p>
                      )}
                      {(item.shoppersLabel === '自定义' && cardInfoConfig.unitPrice && item.custom_unitPrice) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.custom_unitPrice}
                        </p>
                      )}
                    </div>
                    <div className="sale">
                      <div className="price-container">
                        {cardBaseConfig.priceIcon && (
                          <img
                            className="price-icon"
                            src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                          />
                        )}
                        {
                          (item.price || item.price === 0) && (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                            this.rederSparePriceView(baseConfig, item.price, 2)
                          )
                        }
                        {
                          cardInfoConfig.newUserPrice === '新人价' && (
                            this.rederSparePriceView(baseConfig, item.new_user_price || item.price, 2)
                          )
                        }
                        {cardInfoConfig.priceInfo === '原价' &&
                          item.original_price > 0 && item.original_price > item.price && utils.showRightPrice(this.renderPriceLength, item.original_price, 13) && (
                            <span className="origin-price" style={{color: baseConfig.priceInfoColor}}>
                            ¥{item.original_price}
                            </span>
                        )}
                        {cardInfoConfig.priceInfo === '折扣' && discountRate != 10 && (
                          <div className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</div>
                        )}
                      </div>
                      {cardInfoConfig.saleNum === '销量' && item.id && item.sell_point > 0 && utils.showRightPrice(this.renderPriceLength, item.sell_point_str, 10)  && (
                        <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                      )}
                    </div>
                  </div>
                  { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                </div>
              );
            } else if (cardBaseConfig.productStyle === "一行三个") {
              // 四个展示都存在是，隐藏销量
              if ((cardBaseConfig.priceIcon || cardInfoConfig.priceInfo !== '无') && cardInfoConfig.saleNum === '销量') {
                cardInfoConfig.saleNum = '无';
              }
              // 计算一行三商品图片宽度
              const productImgWidth = (bodyWidth - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)  * 2) / 3 - 8;
              let itemClass = 'product-item row-three-item';
              if (showRectImg) {
                itemClass += ' category-shoes'
              }
              if (cardInfoConfig.slogen || cardInfoConfig.unitPrice) {
                itemClass += ' has-benefit'
              } else {
                itemClass += ' no-benefit'
              }

              let labelOrRecommend = null;
              if (cardInfoConfig.slogen) {
                if (cardInfoConfig.priority === '优先展示配色') {
                  if (item.style_name) {
                    labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.style_name}</p>
                  } else {
                    if (item.recommend && !labelOrRecommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>
                    }
                    if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    }
                    if (!labelOrRecommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>
                    }
                  }
                } else if (cardInfoConfig.priority === '优先展示标签') {
                  if ((item.labels && item.labels.length > 0)) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  } else {
                    if (item.style_name && !labelOrRecommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.style_name}</p>
                    }
                    if (!labelOrRecommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend || item.pocket}</p> 
                    }
                  }
                } else {
                  if (item.recommend) {
                    labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>
                  } else {
                    if (item.style_name && !labelOrRecommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.style_name}</p>
                    }
                    if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    }
                    if (!labelOrRecommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>
                    }
                  }
                }
              }
              const options = this.getTrackData(item, index);
              productItem = (
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                  className={itemClass}
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                >
                  <div className={showRectImg ? 'product-img-panel shoes' : 'product-img-panel'}>
                    <div className="img-wrap">
                      <LazyLoadImage
                        width={productImgWidth}
                        height={!showRectImg ? productImgWidth : ''}
                        className="img"
                        effect="opacity"
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                        src={utils.formatImgUrl(!showRectImg ? item.image : item.rectImg, this.props.webpSupport, 'card')}
                      />
                    </div>
                  </div>
                  <div className={utils.isAndroid() ? 'product-info android' : 'product-info'}>
                    <div className="info">
                      <div
                        className={cardInfoConfig.slogen && cardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                        style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor }}
                      >
                        {item.title}
                      </div>
                      {labelOrRecommend}
                      {(item.shoppersLabel === '单位价格' && cardInfoConfig.unitPrice && item.unit_price_text) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.unit_price_text}
                        </p>
                      )}
                      {(item.shoppersLabel === '自定义' && cardInfoConfig.unitPrice && item.custom_unitPrice) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.custom_unitPrice}
                        </p>
                      )}
                    </div>
                    <div className="sale">
                      <div className="price-container">
                        {cardBaseConfig.priceIcon && (
                          <img
                            className="price-icon"
                            src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                          />
                        )}
                        {
                          (item.price || item.price === 0) && (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                            this.rederSparePriceView(baseConfig, item.price, 3)
                          )
                        }
                        {
                          cardInfoConfig.newUserPrice === '新人价' && (
                            this.renderPromotionSpareNewUserPriceView(item.new_user_price || item.price, 2)
                          )
                        }
                        {!cardBaseConfig.priceIcon && cardInfoConfig.priceInfo === '原价' &&
                          item.original_price > item.price &&
                          item.original_price > 0 && utils.showRightPrice(this.renderPriceLength, item.original_price, 9) && (
                            <span className="origin-price" style={{color: baseConfig.priceInfoColor}}>
                              ¥{item.original_price}
                            </span>
                        )}
                        {!cardBaseConfig.priceIcon && cardInfoConfig.priceInfo === '折扣' && discountRate != 10 && utils.showRightPrice(this.renderPriceLength, discountRate, 8) && (
                          <div className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</div>
                        )}
                      </div>
                      {!cardBaseConfig.priceIcon && cardInfoConfig.saleNum === '销量' && cardInfoConfig.priceInfo === '无' && item.sell_point > 0 && utils.showRightPrice(this.renderPriceLength, item.sell_point_str, 5) && (
                        <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                      )}
                    </div>
                  </div>
                  { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                </div>
              );
            }
            return productItem;
          })}
        </div>
      )
    } else if (cardBaseConfig.productStyle === '一行一排') {
      return this.renderLayoutRowNormal();
    } else {
      return this.renderLayoutAdaptNormal();
    }
  }

  // 促销样式
  renderPromotionType() {
    let { productList = [], showPage, showRectImg } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig = {}, promotionCardInfoConfig = {} } = this.formatProductData(this.props.config);

    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
    let itemMargin = 0;
    // 判断不同布局方式下的间距取值
    if (cardBaseConfig.productStyle === "一行一个") {
      itemMargin = 8;
      Object.assign(cardBaseConfig, cardBaseConfig.layout_1);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 6) : productList.slice(0, 6 + 20 * (showPage - 1))) : productList;
    } else if (cardBaseConfig.productStyle === "一行两个") {
      itemMargin = 8;
      Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 6) : productList.slice(0, 6 + 40 * (showPage - 1))) : productList;
    } else if (cardBaseConfig.productStyle === "一行三个") {
      itemMargin = 4;
      Object.assign(cardBaseConfig, cardBaseConfig.layout_3);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 12) : productList.slice(0, 12 + 60 * (showPage - 1))) : productList;
    } else if (cardBaseConfig.productStyle === "一行一排") {
      itemMargin = 4;
      Object.assign(cardBaseConfig, cardBaseConfig.layout_row);
      productList = productList;
    } else if (cardBaseConfig.productStyle === "多个商品，自动适配") {
      itemMargin = 4;
      Object.assign(cardBaseConfig, cardBaseConfig.layout_adapt);
      productList = productList;
    }
    // 转为数字处理，后续参与计算
    cardBaseConfig.itemMargin = itemMargin;
    if (['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0) {
      return (
        <div className="product-list product-list-promotion">
          {
            productList.map((item, index) => {
              let rowItemNumber = 3; // 每行排列数量
              if (cardBaseConfig.productStyle === "一行一个") {
                rowItemNumber = 1;
              } else if (cardBaseConfig.productStyle === "一行两个") {
                rowItemNumber = 2;
              } else if (cardBaseConfig.productStyle === "一行三个") {
                rowItemNumber = 3;
              }
    
              // 折扣计算
              let discountRate = item.price / item.original_price;
              if (
                discountRate > 1 ||
                isNaN(discountRate) ||
                item.original_price === 0
              ) {
                discountRate = 1;
              }
              discountRate = discountRate * 10;
              discountRate = parseFloat(discountRate.toFixed(1));

              // 直降计算
              let plummet = 0;
              if (item.original_price && item.original_price > item.price) {
                plummet = Math.floor(item.original_price - item.price);
              }
    
              // 行数计算
              const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
              const totalRowNum = Math.ceil(productList.length / rowItemNumber);
              const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
              const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
              const isFirstColumn = Boolean(index % rowItemNumber === 0);
              const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

              // 是否展示销量
              const showSaleNum = promotionCardInfoConfig.saleNum === '销量' && item.sell_point > 0;
    
              // 计算每个项的宽度
              const totalMargin = (rowItemNumber - 1) * cardBaseConfig.itemMargin;
              const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
              const itemStyle = {
                width: itemWidth,
                marginTop: isFirstRow ? "0" : `${cardBaseConfig.itemMargin / 2}px`,
                marginBottom: isLasthRow
                  ? "0"
                  : `${cardBaseConfig.itemMargin / 2}px`,
                marginLeft: isFirstColumn
                  ? "0"
                  : `${cardBaseConfig.itemMargin / 2}px`,
                marginRight: isLastColumn
                  ? "0"
                  : `${cardBaseConfig.itemMargin / 2}px`,
              };
    
              let productItem;
              if (cardBaseConfig.productStyle === "一行一个") {
                let labelOrRecommend = null;
                if (promotionCardInfoConfig.slogen) {
                  if (promotionCardInfoConfig.priority === '优先展示标签') {
                    if ((item.labels && item.labels.length > 0)) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend || item.pocket}</p>;
                    }
                  } else {
                    if (item.recommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>;
                    } else {
                      if (item.labels && item.labels.length > 0) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      } else {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>;
                      }
                    }
                  }
                }

                const options = this.getTrackData(item, index);

                productItem = (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                    className="product-item row-one-item"
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                  >
                    <div className="product-img-panel">
                      <LazyLoadImage
                        width={px2rem('108px')}
                        height={px2rem('108px')}
                        effect="opacity"
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 108, height: 108}}></span>}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                      />
                    </div>
                    <div className="product-info">
                      <div className="info">
                        <div
                          className={promotionCardInfoConfig.slogen && promotionCardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                          style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor }}
                        >
                          {item.title}
                        </div>
                        {labelOrRecommend}
                        {(promotionCardInfoConfig.unitPrice && item.shoppersLabel === '单位价格' && item.unit_price_text) && (
                          <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                            {item.unit_price_text}
                          </p>
                        )}
                        {(promotionCardInfoConfig.unitPrice && item.shoppersLabel === '自定义' && item.custom_unitPrice) && (
                          <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                            {item.custom_unitPrice}
                          </p>
                        )}
                        {
                          !promotionCardInfoConfig.slogen && !promotionCardInfoConfig.unitPrice && promotionCardInfoConfig.saleNum === '销量' && (
                            <p className="sale-num">
                              {item.sell_point > 0 ? `${item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款` : '火热抢购中'}
                            </p>
                          )
                        }
                      </div>
                      <div className="sale">
                        <div className="price-container">
                          {cardBaseConfig.priceIcon && (
                            <img
                              className="price-icon"
                              src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                            />
                          )}
                          {
                            item.price ? (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                              this.renderPromotionSparePriceView(item.price, 1)
                            ) : (
                              <div className="price small">
                                <span className="rmb-icon">¥</span>
                                <p className="small">0</p>
                              </div>
                            )
                          }
                          {
                            cardInfoConfig.newUserPrice === '新人价' && (
                              this.renderPromotionSparePriceView(item.new_user_price || item.price, 1)
                            )
                          }
                          {
                            promotionCardInfoConfig.priceInfo === '原价' && utils.showRightPrice(this.renderPriceLength, item.original_price, 12) && (
                              <span className="origin-price" style={{textDecoration: (item.original_price > 0 && item.original_price != item.price) ? 'line-through' : 'none'}}>
                                {
                                  (item.original_price 
                                    && item.original_price > 0
                                      && item.original_price != item.price)
                                        ? `¥${item.original_price}`
                                        : '爆款好价'
                                      }
                              </span>
                            )
                          }
                          {
                            promotionCardInfoConfig.priceInfo === '折扣' && utils.showRightPrice(this.renderPriceLength, discountRate, 11) && (
                              <p className="discount">
                                {discountRate != 10 ? `${discountRate}折` : '爆款好价'}
                              </p>
                            )
                          }
                          {
                            promotionCardInfoConfig.priceInfo === '直降' && utils.showRightPrice(this.renderPriceLength, plummet, 11) && (
                              <p className="plummet">{plummet > 0 ? `直降¥${plummet}` : '爆款好价'}</p>
                            )
                          }
                        </div>
                        <div className="action-btn">
                          <p className={(promotionCardInfoConfig.slogen || promotionCardInfoConfig.unitPrice) && showSaleNum ? 'scramble show-sale-num' : 'scramble'}>抢</p>
                          {
                            (promotionCardInfoConfig.slogen || promotionCardInfoConfig.unitPrice) && showSaleNum && (
                              <p className="sale-num">
                                {item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款
                              </p>
                             )
                          }
                        </div>
                      </div>
                    </div>
                    { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  </div>
                );
              } else if (cardBaseConfig.productStyle === "一行两个") {
                // 计算一行二商品图片宽度
                const productImgWidth = (bodyWidth - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)) / 2 - 8;
                let priceExtra = '';

                if (promotionCardInfoConfig.priceInfo === '原价') {
                  priceExtra = item.original_price > 0 && item.original_price > item.price && `¥${item.original_price}`;
                } else if (promotionCardInfoConfig.priceInfo === '折扣') {
                  priceExtra = discountRate != 10 && `${discountRate}折`;
                } else if (promotionCardInfoConfig.priceInfo === '直降') {
                  priceExtra = plummet > 0 && `直降¥${plummet}`;
                }

                if (item.hasOwnProperty('id') && !priceExtra) {
                  priceExtra = '爆款好价'
                }

                let itemClass = 'product-item row-two-item';
                if (showRectImg) {
                  itemClass += ' category-shoes'
                }
                if (promotionCardInfoConfig.benefit !== "无") {
                  itemClass += ' has-benefit'
                } else {
                  itemClass += ' no-benefit'
                }

                let labelOrRecommend = null;
                if (promotionCardInfoConfig.benefit === '标签&推荐理由') {
                  if (promotionCardInfoConfig.priority === '优先展示标签') {
                    if ((item.labels && item.labels.length > 0)) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend || item.pocket}</p>
                    }
                  } else {
                    if (item.recommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>
                    } else {
                      if (item.labels && item.labels.length > 0) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      } else {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>
                      }
                    }
                  }
                }

                const options = this.getTrackData(item, index);

                productItem = (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                    className={itemClass}
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                  >
                    <div className={showRectImg ? 'product-img-panel shoes' : 'product-img-panel'}>
                      <div className="img-wrap">
                        <LazyLoadImage
                          width={productImgWidth}
                          height={!showRectImg ? productImgWidth : ''}
                          className="img"
                          effect="opacity"
                          placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                          src={utils.formatImgUrl(!showRectImg ? item.image : item.rectImg, this.props.webpSupport, 'card')}
                        />
                        {
                          item.beltImg && <img src={utils.formatImgUrl(item.beltImg, this.props.webpSupport, 'card')} alt="" className="beltImg" />
                        }
                      </div>
                    </div>
                    <div className="product-info">
                      <div className="info">
                        <p
                          className={promotionCardInfoConfig.slogen && promotionCardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                          style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                        >
                          {item.title}
                        </p>
                        {labelOrRecommend}
                        {
                          (
                            promotionCardInfoConfig.benefit === '单位价格'&& item.shoppersLabel === '单位价格' && item.unit_price_text) && (
                              <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                                {item.unit_price_text}
                              </p>
                          )
                        }
                        {
                          (
                            promotionCardInfoConfig.benefit === '单位价格' && item.shoppersLabel === '自定义' && item.custom_unitPrice) && (
                              <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                                {item.custom_unitPrice}
                              </p>
                          )
                        }
                      </div>
                      <div className="sale">
                        {
                          item.price ? (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                            this.renderPromotionSparePriceView(item.price, 2)
                          ) : (
                            <div className="price small">
                              <span className="rmb-icon">¥</span>
                              <p className="small">0</p>
                            </div>
                          )
                        }
                        {
                          cardInfoConfig.newUserPrice === '新人价' && (
                            this.renderPromotionSpareNewUserPriceView(item.new_user_price || item.price, 2)
                          )
                        }
                        <p
                          className="origin-price"
                          style={{
                            textDecoration: 'none'
                          }}
                        >
                          {priceExtra}
                        </p>
                        <p className="num">
                          { 
                            item.sell_point > 0
                              ? `${item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款`
                              : '热卖中'
                          }
                        </p>
                      </div>
                    </div>
                    { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  </div>
                );
              } else if (cardBaseConfig.productStyle === "一行三个") {
                // 计算一行三商品图片宽度
                const productImgWidth = (bodyWidth - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)  * 2) / 3 - 8;
                let priceExtra = '';

                if (promotionCardInfoConfig.priceInfo === '原价') {
                  priceExtra = item.original_price > 0 && item.original_price > item.price && `¥${item.original_price}`;
                } else if (promotionCardInfoConfig.priceInfo === '折扣') {
                  priceExtra = discountRate != 10 && `${discountRate}折`;
                } else if (promotionCardInfoConfig.priceInfo === '直降') {
                  priceExtra = plummet > 0 && `直降¥${plummet}`;
                }

                if (item.hasOwnProperty('id') && !priceExtra) {
                  priceExtra = '爆款好价'
                }

                let itemClass = 'product-item row-three-item';
                if (showRectImg) {
                  itemClass += ' category-shoes'
                }
                if (promotionCardInfoConfig.benefit !== "无") {
                  itemClass += ' has-benefit'
                } else {
                  itemClass += ' no-benefit'
                }

                let labelOrRecommend = null;
                if (promotionCardInfoConfig.benefit === '标签&推荐理由' || promotionCardInfoConfig.benefit === '标签&推荐理由&配色') {
                  if (promotionCardInfoConfig.priority === '优先展示配色') {
                    if (item.style_name) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.style_name}</p>;
                    } else {
                      if (item.recommend) {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>;
                      }
                      if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>;
                      }
                    }
                  } else if (promotionCardInfoConfig.priority === '优先展示标签') {
                    if ((item.labels && item.labels.length > 0)) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      if (item.style_name && !labelOrRecommend) {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.style_name}</p>;
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend || item.pocket}</p>;
                      }
                    }
                  } else {
                    if (item.recommend) {
                      labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.recommend}</p>;
                    } else {
                      if (item.style_name && !labelOrRecommend) {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.style_name}</p>
                      }
                      if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>{item.pocket}</p>
                      }
                    }
                  }
                }

                const options = this.getTrackData(item, index);

                productItem = (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                    className={itemClass}
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                  >
                    <div className={showRectImg ? 'product-img-panel shoes' : 'product-img-panel'}>
                      <div className="img-wrap">
                        <LazyLoadImage
                          width={productImgWidth}
                          height={!showRectImg ? productImgWidth : ''}
                          className="img"
                          effect="opacity"
                          placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                          src={utils.formatImgUrl(!showRectImg ? item.image : item.rectImg, this.props.webpSupport, 'card')}
                        />
                        {
                          item.beltImg && <img src={utils.formatImgUrl(item.beltImg, this.props.webpSupport, 'card')} alt="" className="beltImg" />
                        }
                      </div>
                    </div>
                    <div className="product-info">
                      <div className="info">
                        <p
                          className={promotionCardInfoConfig.slogen && promotionCardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                          style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                        >
                          {item.title}
                        </p>
                        {labelOrRecommend}
                        {
                          (
                            promotionCardInfoConfig.benefit === '单位价格'&& item.shoppersLabel === '单位价格' && item.unit_price_text) && (
                              <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                                {item.unit_price_text}
                              </p>
                          )
                        }
                        {
                          (
                            promotionCardInfoConfig.benefit === '单位价格' && item.shoppersLabel === '自定义' && item.custom_unitPrice) && (
                              <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                                {item.custom_unitPrice}
                              </p>
                          )
                        }
                      </div>
                      <div className="sale">
                        {
                          item.price ? (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                            this.renderPromotionSparePriceView(item.price, 3)
                          ) : (
                            <div className="price small">
                              <span className="rmb-icon">¥</span>
                              <p className="small">0</p>
                            </div>
                          )
                        }
                        {
                          cardInfoConfig.newUserPrice === '新人价' && (
                            this.renderPromotionSparePriceView(item.price || item.new_user_price, 3)
                          )
                        }
                        <p 
                          className="origin-price"
                          style={{
                            textDecoration: 'none'
                          }}
                        >
                          {priceExtra}
                        </p>
                        <p className="num">
                          { 
                            item.sell_point > 0
                              ? `${item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款`
                              : '热卖中'
                          }
                        </p>
                      </div>
                    </div>
                    { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  </div>
                );
              }
              return productItem;
            })
          }
        </div>
      )
    } else if (cardBaseConfig.productStyle === '一行一排') {
      return this.renderLayoutRowPromotion();
    } else {
      return this.renderLayoutAdaptPromotion();
    }
  }

  // 主题促销样式
  renderThemeSaleType() {
    let { productList = [], showPage, showRectImg } = this.state;
    const { baseConfig, cardBaseConfig, themeSaleCardInfoConfig = {} } = this.formatProductData(this.props.config);
    const { themeStyle = '', priceBgTheme_1 = '', priceBgTheme_2 = '', productNameColor = '', productTagColor = '', cardBackgroundColor = '' } = cardBaseConfig;
    const { benefit = '', priority = '' } = themeSaleCardInfoConfig;

    // 判断不同布局方式下的间距取值
    if (cardBaseConfig.productStyle === "一行三个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_3);
      productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 12) : productList.slice(0, 12 + 60 * (showPage - 1))) : productList;
    }

    if (['一行三个'].indexOf(cardBaseConfig.productStyle) >= 0) {
      return (
        <div className={`product-themeSale ${this.isAndroid ? 'android' : 'ios'}`}>
          {
            productList.map((item, index) => {
              let rowItemNumber = 3; // 每行排列数量
              if (cardBaseConfig.productStyle === "一行三个") {
                rowItemNumber = 3;
              }
    
              // 折扣计算
              const discountRate = this.getDiscount(item.price, item.original_price);

              let productItem;
              if (cardBaseConfig.productStyle === "一行三个") {
                // 四个展示都存在是，隐藏销量
                let itemClass = `row-three-item ${themeStyle === '样式一' ? 'theme-1' : 'theme-2'}`;
                if (showRectImg) {
                  itemClass += ' category-shoes'
                }
                if (benefit !== '无') {
                  itemClass += ' has-benefit'
                } else {
                  itemClass += ' no-benefit'
                }
                itemClass = this.getClassRowColumn(itemClass, rowItemNumber, productList.length, index);

                let renderBenefit = ``;
                switch (benefit) {
                  case '原价':
                    renderBenefit = item.original_price && <p className="benefit" style={{ color: productTagColor, textDecoration: 'line-through' }}>¥{item.original_price}</p>;
                    break;
                  case '折扣':
                    renderBenefit = discountRate && <p className="benefit" style={{ color: productTagColor }}>{discountRate}</p>;
                    break;
                  case '销量':
                    renderBenefit = item.sell_point_str && <p className="benefit" style={{ color: productTagColor }}>{`${item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款`}</p>;
                    break;
                  case '标签&推荐理由':
                  case '标签&推荐理由&配色':
                    if (priority === '优先展示配色') {
                      if (item.style_name) {
                        renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.style_name}</p>;
                      } else {
                        if (item.recommend && !renderBenefit) {
                          renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.recommend}</p>;
                        }
                        if ((item.labels && item.labels.length > 0) && !renderBenefit) {
                          renderBenefit = this.renderLabels(item.labels);
                        }
                        if (!renderBenefit) {
                          renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.pocket}</p>;
                        }
                      }
                    } else if (priority === '优先展示标签') {
                      if ((item.labels && item.labels.length > 0)) {
                        renderBenefit = this.renderLabels(item.labels);
                      } else {
                        if (item.style_name && !renderBenefit) {
                          renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.style_name}</p>;
                        }
                        if (!renderBenefit) {
                          renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.recommend || item.pocket}</p>; 
                        }
                      }
                    } else {
                      if (item.recommend) {
                        renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.recommend}</p>;
                      } else {
                        if (item.style_name && !renderBenefit) {
                          renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.style_name}</p>;
                        }
                        if ((item.labels && item.labels.length > 0) && !renderBenefit) {
                          renderBenefit = this.renderLabels(item.labels);
                        }
                        if (!renderBenefit) {
                          renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.pocket}</p>;
                        }
                      }
                    }
                    break;
                  case '单位价格':
                    renderBenefit = <p className="benefit" style={{ color: productTagColor }}>{item.unit_price_text}</p>
                    break;
                  default:
                    break;
                }
                if ((benefit === '标签&推荐理由' || benefit === '标签&推荐理由&配色') && !renderBenefit && item.id) renderBenefit = <p className="benefit" style={{ color: productTagColor }}>爆款热卖</p>;
  
                const options = this.getTrackData(item, index);

                productItem = (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                    className={itemClass}
                    key={index}
                    style={{
                      backgroundColor: cardBackgroundColor
                    }}
                    onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                  >
                    <div className={showRectImg ? 'product-img-panel shoes' : 'product-img-panel'}>
                      <div className="img-wrap">
                        <LazyLoadImage
                          width={px2rem('114px')}
                          height={!showRectImg ? px2rem('114px') : ''}
                          className="img"
                          effect="opacity"
                          placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 114, height: 114}}></span>}
                          src={utils.formatImgUrl(!showRectImg ? item.image : item.rectImg, this.props.webpSupport, 'card')}
                        />
                      </div>
                    </div>
                    <div className={utils.isAndroid() ? 'product-info android' : 'product-info'}>
                      <div
                        className="name"
                        style={{ WebkitBoxOrient: "vertical", color: productNameColor }}
                      >
                        {item.title}
                      </div>
                      { renderBenefit }
                    </div>
                    {
                      themeStyle === '样式一'
                        ? (
                          <div
                            className="product-btn"
                            style={{
                              backgroundImage: `url(${priceBgTheme_1})`,
                              backgroundSize: '100% 100%',
                              backgroundRepeat: 'no-repeat'
                            }
                          }>
                            <p className="label"></p>
                            { this.renderPriceDom(item.price) }
                          </div>
                        ) : (
                          <div
                            className="product-btn"
                            style={{
                              backgroundImage: `url(${priceBgTheme_2})`,
                              backgroundSize: '100% 100%',
                              backgroundRepeat: 'no-repeat'
                            }}
                          >
                            { this.renderPriceDom(item.price) }
                          </div>
                        )
                    }
                    { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  </div>
                );
              }
              return productItem;
            })
          }
        </div>
      )
    }
  }

  // 多个商品自动适配（常规卡片模块）
  renderLayoutAdaptNormal() {
    let { productList = [] } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig = {} } = this.formatProductData(this.props.config);
    Object.assign(cardBaseConfig, cardBaseConfig.layout_adapt);
    let titleSize = 'module-title';
    let showTitleArea = true;
    productList = productList.slice(0, 40);
    if (cardBaseConfig.titleBgImage) {
      if (baseConfig.showSubTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    } else {
      if (baseConfig.showSubTitle && baseConfig.subTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    }
    if ((!baseConfig.title && !baseConfig.subTitle) || (!baseConfig.showTitle && !baseConfig.showSubTitle)) {
      showTitleArea = false;
    }

    let midIndex = 0;
    if (productList.length >= 16 && productList.length <= 40) {
      midIndex = Math.ceil(productList.length / 2)
    }

    let scrollMarginHorizon = px2rem('12px');
    let shopCardMarginBottom = px2rem('12px');
    // if (cardBaseConfig.shopCardMarginHorizon || cardBaseConfig.shopCardMarginHorizon == '0') {
    //   scrollMarginHorizon = px2rem(`${cardBaseConfig.shopCardMarginHorizon}px`);
    // }

    return (
      <div className="product-layout-adapt-normal" style={{backgroundColor: cardBaseConfig.moduleBgColor, borderRadius: cardBaseConfig.moduleBgColor ? px2rem('7px') : 0}}>
        {
          showTitleArea && (
            <div className={titleSize}>
              { cardBaseConfig.titleBgImage && this.renderTitleImage() }
              <div className={cardBaseConfig.titleBgImage ? 'title-content absolute' : 'title-content static'}>
                <div className="title-info">
                  {cardBaseConfig.titlePrefixImage && <img src={utils.formatImgUrl(cardBaseConfig.titlePrefixImage, this.props.webpSupport, 'card')} alt="" className="prefix-img" />}
                  <div className="title-wrap">
                    {baseConfig.showTitle && baseConfig.title && !cardBaseConfig.titleBgImage &&<p className='main-title' style={{color: baseConfig.titleColorRow}}>{baseConfig.title}</p>}
                    {baseConfig.showSubTitle && baseConfig.subTitle && !cardBaseConfig.titleBgImage && <p className="sub-title" style={{color: baseConfig.titleColorRow}}>{baseConfig.subTitle}</p>}
                  </div>
                </div>
                {
                  cardBaseConfig.browserMoreHref && (
                    <div
                      className='more'
                      style={{color: baseConfig.titleColorRow}}
                      onClick={this.productBannerGo.bind(this, cardBaseConfig.browserMoreHref)}
                    >
                      更多
                      <svg t="1658131192314" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1187" className='more-icon'>
                        <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="1188" fill={baseConfig.titleColorRow}></path>
                      </svg>
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <div 
          className={showTitleArea ? "goods-body" : "goods-body no-title-area"}  
          style={{
            paddingTop: px2rem(`${cardBaseConfig.shopCardMarginTop}px`),
            paddingBottom: cardBaseConfig.moduleBgColor ? shopCardMarginBottom : 0
          }}
          ref={ref => this.goodsBodyRef = ref}
        >
          <div className="goods-scroll" ref={ref => this.goodsScrollRef = ref}>
            <div
              className="scroll-list list-1"
              style={{
                marginLeft: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
                marginRight: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
              }}
            >
              { this.renderLayoutAdaptScrollNormal(productList.slice(0, midIndex <= 0 ? productList.length : midIndex)) }
            </div>
            {
              midIndex > 0 && (
                <div
                  className="scroll-list list-2"
                  style={{
                    marginLeft: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
                    marginRight: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
                  }}
                >
                  { this.renderLayoutAdaptScrollNormal(productList.slice(midIndex, productList.length)) }
                </div>
              )
            }
          </div>
        </div>
        { cardBaseConfig.isAutoCarousel === '是' && this.renderCarouselBar() }
      </div>
    )
  }

  // 多个商品自动适配（常规卡片）
  renderLayoutAdaptScrollNormal(list = []) {
    const { baseConfig, cardBaseConfig, cardInfoConfig = {} } = this.formatProductData(this.props.config);
    return (
      <Fragment>
        {
          list.map((item, index) => {
            // 折扣计算
            let discountRate = item.price / item.original_price;
            if (discountRate > 1 || isNaN(discountRate) || item.original_price === 0) {
              discountRate = 1;
            }
            discountRate = discountRate * 10;
            discountRate = parseFloat(discountRate.toFixed(1));

            let itemClass = 'goods-item';
            if (cardInfoConfig.slogen || cardInfoConfig.unitPrice) {
              itemClass += ' has-benefit';
            } else {
              itemClass += ' no-benefit'
            }

            let labelOrRecommend = null;
            if (cardInfoConfig.slogen) {
              if (cardInfoConfig.priority === '优先展示配色') {
                if (item.style_name) {
                  labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                } else {
                  if (item.recommend && !labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.recommend}</p>
                  }
                  if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  }
                  if (!labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.pocket}</p>
                  }
                }
              } else if (cardInfoConfig.priority === '优先展示标签') {
                if ((item.labels && item.labels.length > 0)) {
                  labelOrRecommend = this.renderLabels(item.labels);
                } else {
                  if (item.style_name && !labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                  }
                  if (!labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.recommend || item.pocket}</p>
                  }
                }
              } else {
                if (item.recommend) {
                  labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.recommend}</p>
                } else {
                  if (item.style_name && !labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                  }
                  if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  }
                  if (!labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit" style={{color: cardBaseConfig.productTagColor}}>{item.pocket}</p>
                  }
                }
              }
            }

            const options = this.getTrackData(item, index);

            return (
              <div
                ref={ele => {
                  if (ele) {
                    this.props.exp && this.props.exp(ele);
                  }
                }}
                data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                className={itemClass}
                key={`goods-${index}`}
                style={{
                  backgroundImage: !cardBaseConfig.cardBackgroundColor ? (cardBaseConfig.cardBackground ? `url(${cardBaseConfig.cardBackground})` : 'none') : 'none',
                  border: cardBaseConfig.cardBackground && 'none',
                  backgroundColor: cardBaseConfig.cardBackgroundColor
                }}
                onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
              >
                <div className="goods-item-img">
                  <LazyLoadImage
                    width={px2rem('96px')}
                    height={px2rem('96px')}
                    effect="opacity"
                    src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                  />
                </div>
                <p className="goods-item-title" style={{color: cardBaseConfig.productNameColor}}>
                  {item.title}
                </p>
                {labelOrRecommend}
                <div className="goods-item-bottom" style={{justifyContent: ['原价', '折扣'].indexOf(cardInfoConfig.priceInfo) >= 0 ? 'flex-start' : 'space-between'}}>
                  {
                    (item.price || item.price === 0) && (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                      this.rederSparePriceOneLineView(baseConfig, item.price)
                    )
                  }
                  {
                    cardInfoConfig.newUserPrice === '新人价' && (
                      this.rederSparePriceOneLineView(baseConfig, item.new_user_price || item.price)
                    )
                  }
                  { cardInfoConfig.priceInfo === '原价' && item.original_price > 0 && utils.showRightPrice(this.renderPriceLength, item.original_price, 8) && <p className="origin-price" style={{color: baseConfig.priceInfoColor}}>¥{item.original_price}</p> }
                  { cardInfoConfig.priceInfo === '折扣' && discountRate != 10 && utils.showRightPrice(this.renderPriceLength, discountRate, 8) && <p className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</p> }
                  { cardInfoConfig.priceInfo === '销量' && item.sell_point > 0 && utils.showRightPrice(this.renderPriceLength, item.sell_point_str, 7) && <p className="sales" style={{color: baseConfig.priceInfoColor}}>销量{item.sell_point_str}</p> }
                </div>
                { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
              </div>
            )
          })
        }
      </Fragment>
    )
  }

  // 多个商品自动适配（促销卡片模块）
  renderLayoutAdaptPromotion() {
    let { productList = [] } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig = {}, promotionCardInfoConfig = {} } = this.formatProductData(this.props.config);
    Object.assign(cardBaseConfig, cardBaseConfig.layout_adapt);
    let titleSize = 'module-title';
    let showTitleArea = true;
    productList = productList.slice(0, 40);
    if (cardBaseConfig.titleBgImage) {
      if (baseConfig.showSubTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    } else {
      if (baseConfig.showSubTitle && baseConfig.subTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    }
    if ((!baseConfig.title && !baseConfig.subTitle) || (!baseConfig.showTitle && !baseConfig.showSubTitle)) {
      showTitleArea = false;
    }

    let midIndex = 0;
    if (productList.length >= 16 && productList.length <= 40) {
      midIndex = Math.ceil(productList.length / 2)
    }

    let scrollMarginHorizon = px2rem('12px');
    let shopCardMarginBottom = px2rem('12px');
    // if (cardBaseConfig.shopCardMarginHorizon || cardBaseConfig.shopCardMarginHorizon == '0') {
    //   scrollMarginHorizon = px2rem(`${cardBaseConfig.shopCardMarginHorizon}px`);
    // }

    return (
      <div className="product-layout-adapt-promotion" style={{backgroundColor: cardBaseConfig.moduleBgColor, borderRadius: cardBaseConfig.moduleBgColor ? px2rem('7px') : 0}}>
        {
          showTitleArea && (
            <div className={titleSize}>
              { cardBaseConfig.titleBgImage && this.renderTitleImage() }
              <div className={cardBaseConfig.titleBgImage ? 'title-content absolute' : 'title-content static'}>
                <div className="title-info">
                  {cardBaseConfig.titlePrefixImage && <img src={utils.formatImgUrl(cardBaseConfig.titlePrefixImage, this.props.webpSupport, 'card')} alt="" className="prefix-img" />}
                  <div className="title-wrap">
                    {baseConfig.showTitle && baseConfig.title && !cardBaseConfig.titleBgImage &&<p className='main-title' style={{color: baseConfig.titleColorRow}}>{baseConfig.title}</p>}
                    {baseConfig.showSubTitle && baseConfig.subTitle && !cardBaseConfig.titleBgImage && <p className="sub-title" style={{color: baseConfig.titleColorRow}}>{baseConfig.subTitle}</p>}
                  </div>
                </div>
                {
                  cardBaseConfig.browserMoreHref && (
                    <div
                      className='more'
                      style={{color: baseConfig.titleColorRow}}
                      onClick={this.productBannerGo.bind(this, cardBaseConfig.browserMoreHref)}
                    >
                      更多
                      <svg t="1658131192314" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1187" className='more-icon'>
                        <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="1188" fill={baseConfig.titleColorRow}></path>
                      </svg>
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <div 
          className={showTitleArea ? "goods-body" : "goods-body no-title-area"}  
          style={{
            paddingTop: `${cardBaseConfig.shopCardMarginTop}px`,
            paddingBottom: cardBaseConfig.moduleBgColor ? shopCardMarginBottom : 0,
          }}
          ref={ref => this.goodsBodyRef = ref}
        >
          <div className="goods-scroll" ref={ref => this.goodsScrollRef = ref}>
            <div
              className="scroll-list list-1"
              style={{
                marginLeft: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
                marginRight: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
              }}
            >
              { this.renderLayoutAdaptScrollPromotion(productList.slice(0, midIndex <= 0 ? productList.length : midIndex)) }
            </div>
            {
              midIndex > 0 && (
                <div
                  className="scroll-list list-2"
                  style={{
                    marginLeft: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
                    marginRight: cardBaseConfig.moduleBgColor ? scrollMarginHorizon : 0,
                  }}
                >
                  { this.renderLayoutAdaptScrollPromotion(productList.slice(midIndex, productList.length)) }
                </div>
              )
            }
          </div>
        </div>
        { cardBaseConfig.isAutoCarousel === '是' && this.renderCarouselBar() }
      </div>
    )
  }

  // 多个商品自动适配（促销卡片）
  renderLayoutAdaptScrollPromotion(list = []) {
    const { baseConfig, cardBaseConfig, cardInfoConfig = {}, promotionCardInfoConfig = {} } = this.formatProductData(this.props.config);
    return (
      <Fragment>
        {
          list.map((item, index) => {
            // 折扣计算
            let discountRate = item.price / item.original_price;
            if (discountRate > 1 || isNaN(discountRate) || item.original_price === 0) {
              discountRate = 1;
            }
            discountRate = discountRate * 10;
            discountRate = parseFloat(discountRate.toFixed(1));

            // 直降计算
            let plummet = 0;
            if (item.original_price && item.original_price > item.price) {
              plummet = Math.floor(item.original_price - item.price);
            }

            // 价格信息展示
            let priceExtra = '';
            if (promotionCardInfoConfig.priceInfo === '原价') {
              priceExtra = item.original_price > 0 && item.original_price > item.price && `¥${item.original_price}`;
            } else if (promotionCardInfoConfig.priceInfo === '折扣') {
              priceExtra = discountRate != 10 && `${discountRate}折`;
            } else if (promotionCardInfoConfig.priceInfo === '直降') {
              priceExtra = plummet > 0 && `直降¥${plummet}`;
            }

            if (item.hasOwnProperty('id') && !priceExtra) {
              priceExtra = '爆款好价'
            }

            let labelOrRecommend = null;
            if (promotionCardInfoConfig.benefit === '标签&推荐理由' || promotionCardInfoConfig.benefit === '标签&推荐理由&配色') {
              if (promotionCardInfoConfig.priority === '优先展示配色') {
                if (item.style_name) {
                  labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                } else {
                  if (item.recommend && !labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.recommend}</p>
                  }
                  if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  }
                  if (!labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.pocket}</p>
                  }
                }
              } else if (promotionCardInfoConfig.priority === '优先展示标签') {
                if ((item.labels && item.labels.length > 0)) {
                  labelOrRecommend = this.renderLabels(item.labels);
                } else {
                  if (item.style_name && !labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                  }
                  if (!labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.recommend || item.pocket}</p> 
                  }
                }
              } else {
                if (item.recommend) {
                  labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.recommend}</p>
                } else {
                  if (item.style_name && !labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                  }
                  if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                    labelOrRecommend = this.renderLabels(item.labels);
                  }
                  if (!labelOrRecommend) {
                    labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.pocket}</p>
                  }
                }
              }
            }

            const options = this.getTrackData(item, index);

            return (
              <div
                ref={ele => {
                  if (ele) {
                    this.props.exp && this.props.exp(ele);
                  }
                }}
                data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                className={promotionCardInfoConfig.benefit !== "无" ? 'goods-item has-benefit' : 'goods-item no-benefit'}
                key={`goods-${index}`}
                onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
              >
                <div className="goods-item-img">
                  <LazyLoadImage
                    width={px2rem('96px')}
                    height={px2rem('96px')}
                    effect="opacity"
                    src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                  />
                </div>
                <div className="goods-info">
                  <p className="goods-item-title" style={{color: cardBaseConfig.productNameColor}}>
                    {item.title}
                  </p>
                  {labelOrRecommend}
                  {
                    promotionCardInfoConfig.benefit === '单位价格' && (
                      <p
                        className="goods-item-benefit unit-price"
                        style={{color: cardBaseConfig.productTagColor}}
                      >
                        {item.unit_price_text}
                      </p>
                    )
                  }
                </div>
                <div className="goods-item-bottom">
                  {
                    item.price ? (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                      this.rederLayoutRowPromotionOneLineView(item.price)
                    ) : (
                      <div className="goods-item-price">
                        <span className="rmb-icon">¥</span>
                        <p className="small">0</p>
                      </div>
                    )
                  }
                  {
                    cardInfoConfig.newUserPrice === '新人价' && (
                      this.rederLayoutRowPromotionOneLineView(item.new_user_price || item.price, 'new')
                    )
                  }
                  <p 
                    className="origin-price"
                    style={{
                      textDecoration: 'none'
                    }}
                  >
                    {priceExtra}
                  </p>
                  <p className="sales">
                    { 
                      item.sell_point > 0
                        ? `${item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款`
                        : '热卖中'
                    }
                  </p>
                </div>
                { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
              </div>
            )
          })
        }
      </Fragment>
    )
  }

  // 一行一排（常规样式）
  renderLayoutRowNormal() {
    const { productList = [] } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig = {} } = this.formatProductData(this.props.config);
    Object.assign(cardBaseConfig, cardBaseConfig.layout_row);
    let titleSize = 'module-title';
    let showTitleArea = true;
    if (cardBaseConfig.titleBgImage) {
      if (baseConfig.showSubTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    } else {
      if (baseConfig.showSubTitle && baseConfig.subTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    }
    if ((!baseConfig.title && !baseConfig.subTitle) || (!baseConfig.showTitle && !baseConfig.showSubTitle)) {
      showTitleArea = false;
    }
    this.renderPriceLength = this.renderPriceLength || 0;//一行一 价格长度
    return (
      <div className="product-layout-row-normal" style={{backgroundColor: cardBaseConfig.moduleBgColor}}>
        {
          showTitleArea && (
            <div className={titleSize}>
              { cardBaseConfig.titleBgImage && this.renderTitleImage() }
              <div className={cardBaseConfig.titleBgImage ? 'title-content absolute' : 'title-content static'}>
                {
                  !cardBaseConfig.titleBgImage && (
                    <div className="title-info">
                      {cardBaseConfig.titlePrefixImage && <img src={utils.formatImgUrl(cardBaseConfig.titlePrefixImage, this.props.webpSupport, 'card')} alt="" className="prefix-img" />}
                      <div className="title-wrap">
                        {baseConfig.showTitle && baseConfig.title && !cardBaseConfig.titleBgImage &&<p className='main-title' style={{color: baseConfig.titleColorRow}}>{baseConfig.title}</p>}
                        {baseConfig.showSubTitle && baseConfig.subTitle && !cardBaseConfig.titleBgImage && <p className="sub-title" style={{color: baseConfig.titleColorRow}}>{baseConfig.subTitle}</p>}
                      </div>
                    </div>
                  )
                }
                {
                  cardBaseConfig.browserMoreHref && (
                    <div className="more-hot" onClick={this.productBannerGo.bind(this, cardBaseConfig.browserMoreHref)}>
                      {
                        !cardBaseConfig.titleBgImage && (
                          <div
                            className='more'
                            style={{color: baseConfig.titleColorRow}}
                          >
                            更多
                            <svg t="1658131192314" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1187" className='more-icon'>
                              <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="1188" fill={baseConfig.titleColorRow}></path>
                            </svg>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <div className={showTitleArea ? "goods-body" : "goods-body no-title-area"}>
          <div className="goods-scroll">
            {
              productList.slice(0, 20).map((item, index) => {
                // 折扣计算
                let discountRate = item.price / item.original_price;
                if (discountRate > 1 || isNaN(discountRate) || item.original_price === 0) {
                  discountRate = 1;
                }
                discountRate = discountRate * 10;
                discountRate = parseFloat(discountRate.toFixed(1));

                let itemClass = 'goods-item';
                if (cardInfoConfig.slogen || cardInfoConfig.unitPrice) {
                  itemClass += ' has-benefit';
                } else {
                  itemClass += ' no-benefit'
                }

                let labelOrRecommend = null;
                if (cardInfoConfig.slogen) {
                  if (cardInfoConfig.priority === '优先展示配色') {
                    if (item.style_name) {
                      labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.style_name}</p>
                    } else {
                      if (item.recommend && !labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.recommend}</p>
                      }
                      if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.pocket}</p>
                      }
                    }
                  } else if (cardInfoConfig.priority === '优先展示标签') {
                    if ((item.labels && item.labels.length > 0)) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      if (item.style_name && !labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.style_name}</p>
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.recommend || item.pocket}</p> 
                      }
                    }
                  } else {
                    if (item.recommend) {
                      labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.recommend}</p>
                    } else {
                      if (item.style_name && !labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.style_name}</p>
                      }
                      if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit" style={{color: (cardBaseConfig.productNameColor != "#333333" && cardBaseConfig.productNameColor != "#333") && cardBaseConfig.productNameColor}}>{item.pocket}</p>
                      }
                    }
                  }
                }

                let scrollMarginHorizon = px2rem('12px');
                if (cardBaseConfig.shopCardMarginHorizon || cardBaseConfig.shopCardMarginHorizon == '0') {
                  scrollMarginHorizon = px2rem(`${cardBaseConfig.shopCardMarginHorizon}px`);
                }
                
                const options = this.getTrackData(item, index);

                return (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                    className={itemClass}
                    key={`goods-${index}`}
                    style={{
                      marginLeft: index === 0 ? scrollMarginHorizon : 0,
                      marginRight: index === productList.slice(0, 20).length - 1 ? scrollMarginHorizon : px2rem('4px')
                    }}
                    onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                  >
                    <div className="goods-item-img">
                      <LazyLoadImage
                        width={px2rem('91px')}
                        height={px2rem('91px')}
                        effect="opacity"
                        src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                      />
                    </div>
                    <p className="goods-item-title" style={{color: cardBaseConfig.productNameColor}}>
                      {item.title}
                    </p>
                    {labelOrRecommend}
                    <div className="goods-item-bottom" style={{justifyContent: ['原价', '折扣'].indexOf(cardInfoConfig.priceInfo) >= 0 ? 'flex-start' : 'space-between'}}>
                      {
                        (item.price || item.price === 0) && (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                          this.rederSparePriceOneLineView(baseConfig, item.price)
                        )
                      }
                      {
                        cardInfoConfig.newUserPrice === '新人价' && (
                          this.rederSparePriceOneLineView(baseConfig, item.new_user_price || item.price)
                        )
                      }
                      { cardInfoConfig.priceInfo === '原价' && item.original_price > 0 && utils.showRightPrice(this.renderPriceLength, item.original_price, 7) && <p className="origin-price" style={{color: baseConfig.priceInfoColor}}>¥{item.original_price}</p> }
                      { cardInfoConfig.priceInfo === '折扣' && utils.showRightPrice(this.renderPriceLength, discountRate, 7) && discountRate != 10 && <p className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</p> }
                      { cardInfoConfig.priceInfo === '销量' && utils.showRightPrice(this.renderPriceLength, item.sell_point_str, 5) && item.sell_point > 0 && <p className="sales" style={{color: baseConfig.priceInfoColor}}>销量{item.sell_point_str}</p> }
                    </div>
                    { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  </div>
                )
              })
            }
            {
              cardBaseConfig.browserMoreHref && (
                <p
                  className={(cardInfoConfig.slogen || cardInfoConfig.unitPrice) ? 'browser-more has-benefit' : 'browser-more no-benefit'}
                  style={{backgroundColor: cardBaseConfig.browserMoreBgColor, color: cardBaseConfig.browserMoreTxtColor}}
                  onClick={this.productBannerGo.bind(this, cardBaseConfig.browserMoreHref)}
                >
                  查看更多
                </p>
              )
            }
          </div>
        </div>
      </div>
    )
  }

  // 一行一排（促销样式）
  renderLayoutRowPromotion() {
    const { productList = [] } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig = {}, promotionCardInfoConfig = {} } = this.formatProductData(this.props.config);
    Object.assign(cardBaseConfig, cardBaseConfig.layout_row);
    let titleSize = 'module-title';
    let showTitleArea = true;
    if (cardBaseConfig.titleBgImage) {
      if (baseConfig.showSubTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    } else {
      if (baseConfig.showSubTitle && baseConfig.subTitle) {
        titleSize += ' big'
      } else {
        titleSize += ' small'
      }
    }
    if ((!baseConfig.title && !baseConfig.subTitle) || (!baseConfig.showTitle && !baseConfig.showSubTitle)) {
      showTitleArea = false;
    }
    return (
      <div className="product-layout-row-promotion" style={{backgroundColor: cardBaseConfig.moduleBgColor}}>
        {
          showTitleArea && (
            <div className={titleSize}>
              { cardBaseConfig.titleBgImage && this.renderTitleImage() }
              <div className={cardBaseConfig.titleBgImage ? 'title-content absolute' : 'title-content static'}>
                {
                  !cardBaseConfig.titleBgImage && (
                    <div className="title-info">
                      {cardBaseConfig.titlePrefixImage && <img src={utils.formatImgUrl(cardBaseConfig.titlePrefixImage, this.props.webpSupport, 'card')} alt="" className="prefix-img" />}
                      <div className="title-wrap">
                        {baseConfig.showTitle && baseConfig.title && !cardBaseConfig.titleBgImage &&<p className='main-title' style={{color: baseConfig.titleColorRow}}>{baseConfig.title}</p>}
                        {baseConfig.showSubTitle && baseConfig.subTitle && !cardBaseConfig.titleBgImage && <p className="sub-title" style={{color: baseConfig.titleColorRow}}>{baseConfig.subTitle}</p>}
                      </div>
                    </div>
                  )
                }
                {
                  cardBaseConfig.browserMoreHref && (
                    <div className="more-hot" onClick={this.productBannerGo.bind(this, cardBaseConfig.browserMoreHref)}>
                      {
                        !cardBaseConfig.titleBgImage && (
                          <div
                            className='more'
                            style={{color: baseConfig.titleColorRow}}
                          >
                            更多
                            <svg t="1658131192314" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1187" className='more-icon'>
                              <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="1188" fill={baseConfig.titleColorRow}></path>
                            </svg>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <div className={showTitleArea ? "goods-body" : "goods-body no-title-area"}>
          <div className="goods-scroll">
            {
              productList.slice(0, 20).map((item, index) => {
                // 折扣计算
                let discountRate = item.price / item.original_price;
                if (discountRate > 1 || isNaN(discountRate) || item.original_price === 0) {
                  discountRate = 1;
                }
                discountRate = discountRate * 10;
                discountRate = parseFloat(discountRate.toFixed(1));

                // 直降计算
                let plummet = 0;
                if (item.original_price && item.original_price > item.price) {
                  plummet = Math.floor(item.original_price - item.price);
                }

                // 价格信息展示
                let priceExtra = '';
                if (promotionCardInfoConfig.priceInfo === '原价') {
                  priceExtra = item.original_price > 0 && item.original_price > item.price && `¥${item.original_price}`;
                } else if (promotionCardInfoConfig.priceInfo === '折扣') {
                  priceExtra = discountRate != 10 && `${discountRate}折`;
                } else if (promotionCardInfoConfig.priceInfo === '直降') {
                  priceExtra = plummet > 0 && `直降¥${plummet}`;
                }

                if (item.hasOwnProperty('id') && !priceExtra) {
                  priceExtra = '爆款好价'
                }

                let labelOrRecommend = null;
                if (promotionCardInfoConfig.benefit === '标签&推荐理由' || promotionCardInfoConfig.benefit === '标签&推荐理由&配色') {
                  // 默认展示优先级 配色 > 推荐理由 > 标签
                  if (promotionCardInfoConfig.priority === '优先展示配色') {
                    if (item.style_name) {
                      labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                    } else {
                      if (item.recommend && !labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.recommend}</p>
                      }
                      if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.pocket}</p>
                      }
                    }
                  } else if (promotionCardInfoConfig.priority === '优先展示标签') {
                    if ((item.labels && item.labels.length > 0)) {
                      labelOrRecommend = this.renderLabels(item.labels);
                    } else {
                      if (item.style_name && !labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.recommend || item.pocket}</p>
                      }
                    }
                  } else {
                    if (item.recommend) {
                      labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.recommend}</p>
                    } else {
                      if (item.style_name && !labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.style_name}</p>
                      }
                      if ((item.labels && item.labels.length > 0) && !labelOrRecommend) {
                        labelOrRecommend = this.renderLabels(item.labels);
                      }
                      if (!labelOrRecommend) {
                        labelOrRecommend = <p className="goods-item-benefit recommend" style={{color: cardBaseConfig.productTagColor}}>{item.pocket}</p>
                      }
                    }
                  }
                }

                let scrollMarginHorizon = px2rem('12px');
                if (cardBaseConfig.shopCardMarginHorizon || cardBaseConfig.shopCardMarginHorizon == '0') {
                  scrollMarginHorizon = px2rem(`${cardBaseConfig.shopCardMarginHorizon}px`);
                }

                const options = this.getTrackData(item, index);

                return (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, options))}
                    className={promotionCardInfoConfig.benefit !== "无" ? 'goods-item has-benefit' : 'goods-item no-benefit'}
                    key={`goods-${index}`}
                    style={{
                      marginLeft: index === 0 ? scrollMarginHorizon : 0,
                      marginRight: index === productList.slice(0, 20).length - 1 ? scrollMarginHorizon : px2rem('4px')
                    }}
                    onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                  >
                    <div className="goods-item-img">
                      <LazyLoadImage
                        width={px2rem('96px')}
                        height={px2rem('96px')}
                        effect="opacity"
                        src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                      />
                    </div>
                    <div className="goods-info">
                      <p className="goods-item-title" style={{color: cardBaseConfig.productNameColor}}>
                        {item.title}
                      </p>
                      {labelOrRecommend}
                      {
                        promotionCardInfoConfig.benefit === '单位价格' && (
                          <p
                            className="goods-item-benefit unit-price"
                            style={{color: cardBaseConfig.productTagColor}}
                          >
                            {item.unit_price_text}
                          </p>
                        )
                      }
                    </div>
                    <div className="goods-item-bottom">
                      {
                        item.price ? (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无') && (
                          this.rederLayoutRowPromotionOneLineView(item.price)
                        ) : (
                          <div className="goods-item-price">
                            <span className="rmb-icon">¥</span>
                            <p className="small">0</p>
                          </div>
                        )
                      }
                      {
                        cardInfoConfig.newUserPrice === '新人价' && (
                          this.rederLayoutRowPromotionOneLineView(item.new_user_price || item.price, 'new')
                        )
                      }
                      <p 
                        className="origin-price"
                        style={{
                          textDecoration: 'none'
                        }}
                      >
                        {priceExtra}
                      </p>
                      <p className="sales">
                        { 
                          item.sell_point > 0
                            ? `${item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款`
                            : '热卖中'
                        }
                      </p>
                    </div>
                    { item.markIcon && <img className={`mark-icon ${custonLabels.includes(item.markIcon) ? 'style-2' : 'style-1'}`} src={utils.formatImgUrl(item.markIcon, this.props.webpSupport)} /> }
                  </div>
                )
              })
            }
            {
              cardBaseConfig.browserMoreHref && (
                <p
                  className={promotionCardInfoConfig.benefit !== "无" ? 'browser-more has-benefit' : 'browser-more no-benefit'}
                  style={{backgroundColor: cardBaseConfig.browserMoreBgColor, color: cardBaseConfig.browserMoreTxtColor}}
                  onClick={this.productBannerGo.bind(this, cardBaseConfig.browserMoreHref)}
                >
                  查看更多
                </p>
              )
            }
          </div>
        </div>
      </div>
    )
  }

  // 渲染标题背景图片
  renderTitleImage() {
    const { cardBaseConfig } = this.formatProductData(this.props.config);
    const { width, height } = utils.getAdaptImageSize(cardBaseConfig.titleImageSize);
    return (
      <img
        src={utils.formatImgUrl(cardBaseConfig.titleBgImage, this.props.webpSupport)}
        alt=""
        className="title-image"
        style={{
          width,
          height
        }}
      />
    )
  }

  // 轮播条
  renderCarouselBar() {
    const { cardBaseConfig } = this.props.config;
    let carouselBgColor, progressColor;
    switch (cardBaseConfig.carouselBarColor) {
      case '白色':
        carouselBgColor = 'rgba(255, 255, 255, 0.3)';
        progressColor = '#fff';
        break;
      case '黑色':
        carouselBgColor = 'rgba(202, 202, 202, 0.3)';
        progressColor = '#CACACA';
        break;
      default:
        carouselBgColor = 'rgba(255, 255, 255, 0.3)';
        progressColor = '#fff';
        break;
    }
    return (
      <div className="carousel-bar">
        <div className="carousel-bg" style={{backgroundColor: carouselBgColor}} ref={ref => this.carouselBgRef = ref}></div>
        <div className="carousel-progress" style={{backgroundColor: progressColor}} ref={ref => this.progressRef = ref}></div>
      </div>
    )
  }

  renderPriceDom = (price = 0) => {
    let priceDom = null, decimals = '', suffix = '';
    if (price > 9999) {
      price = parseFloat((price / 10000).toFixed(1)) + '万'
    } else {
      price = String(price)
    }
    if (price.indexOf('.') >= 0) {
      price = price.split('.');
    }
    if (Array.isArray(price)) {
      if (price[1] && price[1].indexOf('万') >= 0) {
        decimals = price[1].replace('万', '');
        suffix = '万';
      } else {
        decimals = price[1];
      }
      priceDom = (
        <p className={`price ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14ProMax' : ''}`}>
          <span className="symbol">¥</span>
          {price[0]}.
          <span className="decimals">{decimals}</span>
          <span className="suffix">{suffix}</span>
        </p>
      )
    } else {
      if (price.indexOf('万') >= 0) {
        price = price.replace('万', '');
        priceDom = <p className={`price ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14ProMax' : ''}`}><span className="symbol">¥</span>{price}<span className="suffix">万</span></p>
      } else {
        priceDom = <p className={`price ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14ProMax' : ''}`}><span className="symbol">¥</span>{price}</p>
      }
    }
    return priceDom;
  }
  
  // 标签
  renderLabels(labels = []) {
    return (
      <div className="labels">
        {
          labels.map((item, index) => {
            let color = '', borderColor = '', backgroundColor = '';
            if (item.type === 'NEW_GOODS') {
              color = '#3E455E';
              borderColor = '#C8CEE4';
              backgroundColor = 'transparent';
            } else {
              color = '#FF4338';
              borderColor = '#FFB4B3';
              backgroundColor = 'transparent';
            }
            return (
              <p
                key={`label-${index}`}
                className={this.isAndroid ? 'android' : 'ios'}
                style={{
                  color,
                  borderColor,
                  backgroundColor
                }}
              >
                {item.text}
              </p>
            )
          })
        }
      </div>
    )
  }

  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  
    // 判断元素是否垂直方向上可见
    const verticalVisible = rect.top <= windowHeight && rect.bottom >= 0;
  
    // 判断元素是否水平方向上可见
    const horizontalVisible = rect.left <= windowWidth && rect.right >= 0;
  
    // 计算已经暴露在可视区的比例
    const visibleArea = Math.max(0, Math.min(rect.right, windowWidth) - Math.max(rect.left, 0)) *
      Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
  
    const totalArea = rect.width * rect.height;
    const visibilityRatio = visibleArea / totalArea;
  
    return {
      verticalVisible,
      horizontalVisible,
      visibilityRatio
    };
  }

  hexColorToRgba(hexColor, opacity) {
    const alphaMaxVal = 1
    hexColor = hexColor.replace("#", "");
  
    //用于分割16进制色彩通道
    let reg = new RegExp("\\w{1,2}", "g");
    //分割颜色通道
    let rgbaArray255 = hexColor.match(reg);
    rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
      //计算每个通道的10进制值
      let colorVal = parseInt(channel, 16);
      if (index === 3) {
        //这是alpha通道
        return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
      }
      return colorVal;
    });
    return `rgb(${rgbaArray255.join(',')},${opacity})`;
  }
}

PipelineProduct.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineProduct };
export default PipelineProduct;



// WEBPACK FOOTER //
// ./components/pipeline-product/index.js